export const lt = {
  // Header
  header: {
    search: 'Paieška',
    myAccount: 'Mano paskyra',
    login: 'Prisijungti',
    account: 'Paskyra',
    wishlist: 'Norai',
    cart: 'Krepšelis',
    openMenu: 'Atidaryti meniu',
    closeMenu: 'Uždaryti meniu',
    goTo: 'Eiti į',
    show: 'Rodyti',
    products: 'produktus',
    contact: 'Kontaktai',
    productFilters: 'Produktų filtrai',
    clearFilters: 'Išvalyti filtrus',
    category: 'Kategorija',
    skinType: 'Odos tipas',
    priceRange: 'Kainų diapazonas',
    applyFilters: 'Taikyti filtrus',
    allProducts: 'Visi produktai',
    all: 'Visi',
    selectCategory: 'Pasirinkite kategoriją',
    selectSkinType: 'Pasirinkite odos tipą',
  },
  
  // Footer
  footer: {
    description: 'Aukščiausios kokybės grožio ir odos priežiūros produktai, specialiai atrinkti jūsų natūraliam grožiui atsiskleisti.',
    productsBySkinType: 'Produktai pagal odos tipą',
    help: 'Pagalba',
    blog: 'Tinklaraštis',
    contacts: 'Kontaktai',
    delivery: 'Pristatymas',
    returns: 'Grąžinimas',
    faq: 'DUK',
    allRightsReserved: 'Visos teisės saugomos',
    privacyPolicy: 'Privatumo politika',
    termsOfUse: 'Naudojimo sąlygos',
    cookiePolicy: 'Slapukų politika',
  },

  // Cookie Banner
  cookies: {
    title: 'Slapukų nustatymai',
    description: 'Mes naudojame slapukus, kad pagerintume jūsų naršymo patirtį, analizuotume svetainės srautą ir personalizuotume turinį. Galite pasirinkti, kuriuos slapukus leisti.',
    acceptAll: 'Sutikti su visais',
    rejectAll: 'Atmesti nebūtinus',
    settings: 'Nustatymai',
    moreInfo: 'Daugiau informacijos:',
    categoriesTitle: 'Slapukų kategorijos',
    necessary: 'Būtini slapukai',
    necessaryBadge: 'Būtina',
    necessaryDescription: 'Reikalingi svetainės veikimui ir saugumui',
    functional: 'Funkciniai slapukai',
    optionalBadge: 'Pasirinktina',
    functionalDescription: 'Pagerina svetainės funkcionalumą ir naudotojo patirtį',
    analytics: 'Analitiniai slapukai',
    analyticsDescription: 'Padeda suprasti, kaip naudojate svetainę (Google Analytics)',
    marketing: 'Rinkodaros slapukai',
    marketingDescription: 'Naudojami personalizuotai reklamai ir retargetingui',
    saveSettings: 'Išsaugoti nustatymus',
    back: 'Atgal',
    closeSettings: 'Uždaryti slapukų nustatymus',
    saveSelected: 'Išsaugoti pasirinkus slapukų nustatymus',
    backToMain: 'Grįžti į pagrindinį slapukų langą',
    acceptAllLabel: 'Sutikti su visais slapukais',
    rejectAllLabel: 'Atmesti visus nebūtinus slapukus',
    openSettings: 'Atidaryti slapukų nustatymus',
  },
  
  // Blog
  blog: {
    title: 'Grožio ir odos',
    titleHighlight: 'priežiūros tinklaraštis',
    description: 'Ekspertų patarimai, produktų apžvalgos ir naujienos grožio pasaulyje',
    featured: 'Išskirtinis straipsnis',
    readArticle: 'Skaityti straipsnį',
    readMore: 'Skaityti daugiau',
    noResults: 'Pagal pasirinktus filtrus straipsnių nerasta',
    newsletterTitle: 'Gaukite grožio patarimus tiesiai į savo el. paštą',
    newsletterDescription: 'Prenumeruokite mūsų naujienlaiškį ir gaukite ekskluzyvius pasiūlymus bei patarimus',
    clearFilters: 'Išvalyti filtrus',
    ctaTitle: 'Pasiruošę atrasti savo idealius produktus?',
    ctaDescription: 'Naršykite mūsų kruopščiai atrinktą grožio produktų kolekciją',
    ctaButton: 'Žiūrėti produktus',
    relatedPosts: 'Susiję straipsniai',
    backToBlog: 'Atgal į tinklaraštį',
    share: 'Dalintis',
    articleNotFound: 'Straipsnis nerastas',
  },
  
  // Newsletter
  newsletter: {
    title: 'Gaukite grožio patarimus ir išskirtinius pasiūlymus',
    description: 'Prisijunkite prie mūsų grožio bendruomenės ir pirmieji sužinokite apie naujus produktus, ekskluzyvius pasiūlymus ir profesinius grožio patarimus.',
    emailPlaceholder: 'Jūsų el. pašto adresas',
    subscribeButton: 'Prenumeruoti',
    subscribing: 'Prenumeruojama...',
    privacyText: 'Registruodamiesi sutinkate su mūsų',
    privacyLink: 'privatumo politika',
    privacyEndText: '. Galite atsisakyti prenumeratos bet kada.',
    successMessage: 'Sėkmingai prenumeravote!',
    errorTitle: 'Klaida',
    errorDescription: 'Nepavyko prenumeruoti. Bandykite dar kartą.',
    alreadySubscribedTitle: 'Jau prenumeruojate',
    alreadySubscribedDescription: 'Šis el. pašto adresas jau yra mūsų prenumeratorių sąraše',
    subscribeSuccessTitle: 'Sėkmingai prenumeravote!',
    subscribeSuccessDescription: 'Dėkojame už prisijungimą prie mūsų grožio bendruomenės',
    vipBenefits: 'Narystės privilegijos',
    earlyAccess: 'Išankstinė prieiga',
    exclusiveOffers: 'Ekskluzyvūs pasiūlymai',
  },
  
  // Unsubscribe
  unsubscribe: {
    pageTitle: 'Atsisakyti naujienlaiškio prenumeratos',
    pageDescription: 'Atsisakykite naujienlaiškio prenumeratos',
    title: 'Atsisakyti prenumeratos',
    description: 'Įveskite savo el. pašto adresą, kad atsisakytumėte naujienlaiškio prenumeratos.',
    emailPlaceholder: 'Jūsų el. pašto adresas',
    confirmButton: 'Atsisakyti prenumeratos',
    processing: 'Apdorojama...',
    successTitle: 'Prenumerata atšaukta',
    successDescription: 'Jūs sėkmingai atsisakėte naujienlaiškio prenumeratos.',
    successMessage: 'Prenumerata sėkmingai atšaukta',
    successDetail: 'Daugiau nebegausite mūsų naujienlaiškių. Gaila, kad išeinate!',
    errorTitle: 'Klaida',
    errorDescription: 'Nepavyko atšaukti prenumeratos. Bandykite dar kartą.',
    notFoundTitle: 'El. paštas nerastas',
    notFoundDescription: 'Šis el. pašto adresas nėra mūsų prenumeratorių sąraše.',
    tryAgain: 'Bandyti dar kartą',
    backToHome: 'Grįžti į pradžią',
    resubscribeNote: 'Galite bet kada vėl prenumeruoti mūsų naujienlaiškį svetainėje.',
  },

  // Home
  home: {
    metaTitle: 'BeauBox - Premium Grožio ir Odos Priežiūros Produktai',
    metaDescription: 'Atraskite aukščiausios kokybės grožio produktus BeauBox. Premium veido priežiūra, kūno priežiūra, plaukų priežiūra ir kosmetika. Pristatymas visoje Lietuvoje.',
  },

  // Hero
  hero: {
    titleLine1: 'Atraskite savo',
    titleLine2: 'natūralų grožį.',
    subtitle: 'Prabangūs grožio ir odos priežiūros produktai, specialiai atrinkti jūsų unikaliam grožiui atsiskleisti.',
    primaryButton: 'Apsipirkti dabar',
    secondaryButton: 'Sužinoti daugiau',
    imageAlt: 'Grožio produktai',
    stat1Value: '200+',
    stat1Label: 'Produktų',
    stat2Value: '2d*',
    stat2Label: 'Pristatymas',
    stat3Value: '5★',
    stat3Label: 'Vertinimai',
    floating1Title: 'Naujienos',
    floating1Subtitle: 'Siekiantis tobulumo',
    floating2Title: '★ Lojalumo sistema',
    floating2Subtitle: 'Kaupkite taškus ir mokėkite mažiau',
  },
  
  // Product Detail
  productDetail: {
    addToCart: 'Į krepšelį',
    buyNow: 'Pirkti dabar',
    addToWishlist: 'Į norų sąrašą',
    removeFromWishlist: 'Pašalinti iš norų',
    share: 'Dalintis',
    inStock: 'Sandėlyje',
    outOfStock: 'Nėra sandėlyje',
    limitedStock: 'Liko tik {count} vnt.',
    sku: 'Prekės kodas',
    category: 'Kategorija',
    brand: 'Prekės ženklas',
    volume: 'Tūris',
    skinTypes: 'Tinka odos tipams',
    whyChoose: 'Kodėl verta rinktis šį produktą?',
    qualityGuarantee: 'Kokybės garantija',
    qualityGuaranteeText: 'Originalūs produktai iš patikimų gamintojų',
    freeShipping: 'Nemokamas pristatymas',
    freeShippingText: 'Užsakymams nuo 50€',
    fastDelivery: 'Greitas pristatymas',
    fastDeliveryText: '1-3 darbo dienos visoje Lietuvoje',
    securePayment: 'Saugus mokėjimas',
    securePaymentText: 'Šifruotas duomenų apsaugojimas',
    description: 'Aprašymas',
    ingredients: 'Sudėtis',
    usage: 'Naudojimas',
    similarProducts: 'Panašūs produktai',
    customerReviews: 'Klientų atsiliepimai',
    noReviews: 'Atsiliepimų dar nėra',
    basedOnReviews: 'Remiantis {count} atsiliepimais',
    viewAllProducts: 'Žiūrėti visus produktus',
    new: 'Nauja',
    bestseller: 'Populiaru',
    sale: 'Išpardavimas',
    recommended: 'Rekomenduojama',
    files: 'Produkto failai',
    highQuality: 'Aukšta kokybė',
    dermatologicallyTested: 'Dermatologiškai išbandyta',
    naturalIngredients: 'Natūralūs ingredientai',
    otherShoppersViewed: 'Kiti pirkėjai taip pat žiūri',
    youMayLike: 'Jums taip pat gali patikti',
    selectedForYou: 'Atrenkami produktai pagal jūsų pageidavimus ir kitų klientų atsiliepimus',
  },
  
  // Search modal
  searchTitle: "Paieška",
  searchDescription: "Ieškokite produktų pagal pavadinimą, prekės ženklą, kategoriją, aprašymą ar sudėtį",
  searchProducts: "Ieškoti produktų...",
  searching: "Kraunama...",
  noResultsFound: "Produktų nerasta pagal paieškos kriterijus",
  tryDifferentKeywords: "Pabandykite kitus raktažodžius",
  popularSearches: "Populiarios paieškos:",
  browseCategories: "Kategorijos:",
  addToCart: "Į krepšelį",
  results: "rezultatai",
  noCategory: "Nėra kategorijos",
  popularSearchTerms: {
    faceSerum: "Veido serumas",
    moisturizingCream: "Drėkinamasis kremas",
    eyeCream: "Akių kremas",
    micellarWater: "Micelinis vanduo",
    toner: "Tonikas",
  },

  // Price display
  priceDisplay: {
    loginToSeePrices: "Prisijunkite norėdami matyti kainas",
    login: "Prisijungti",
    priceVisibleAfterConsultation: "Kaina matoma po konsultacijos",
  },

  // Cart context messages
  cartMessages: {
    loginRequired: "Prisijunkite",
    loginToAddToCart: "Norint pridėti prekę į krepšelį, reikia prisijungti",
    cartCleared: "Krepšelis išvalytas",
    allItemsRemoved: "Visos prekės pašalintos iš krepšelio",
  },

  // Wishlist context messages
  wishlistMessages: {
    loginRequired: "Prisijunkite",
    loginToAddToWishlist: "Norint pridėti prekę į norų sąrašą, reikia prisijungti",
    alreadyInWishlist: "Prekė jau sąraše",
    alreadyInWishlistDesc: "Ši prekė jau yra jūsų norų sąraše",
  },

  // SEO meta tags for homepage
  seo: {
    homeTitle: "BeauBox - Profesionali Kosmetika Internetu | Kremas Veidui",
    homeDescription: "Profesionali kosmetika internetu: kremas veidui, veido serumas, SPF apsauga, UV indeksas. Ekseption, Fusion Mesotherapy, ClinicCare. Nemokamas pristatymas nuo 60€.",
    homeKeywords: "kosmetologė, kosmetologė rekomenduoja, kosmetologės rekomendacijos, kosmetologė vilnius, kosmetologė kaunas, kosmetologė online, kosmetologė konsultacija, kremas veidui, veido kremas, drėkinantis kremas veidui, prieš raukšlių kremas veidui, maitinamasis kremas veidui, naktinis kremas veidui, dieninis kremas veidui, kosmetika pigiai, pigi kosmetika, kosmetika pigiau, kosmetika akcija, kosmetika nuolaida, kosmetika internetu pigiai, UV indeksas, UV indeksas Lietuvoje, UV indeksas šiandien, apsauga nuo saulės, SPF kremas, drėkinantis kremas, prieš raukšlių kremas, veido serumas, odos priežiūra, grožio produktai, kosmetika, akių kremas, valomosios priemonės, veido prausiklis, aliejinis prausiklis, valiklis, tonikas, kauke, veido kauke, ekseption, fusion mesotherapy, cliniccare, naturys, instinct, profesionali kosmetika, odos priežiūros priemonės lietuvoje, kosmetika internetu, grožio produktai lietuvoje",
    ogTitle: "BeauBox - Kosmetologė Rekomenduoja | Profesionalūs Grožio Produktai Lietuvoje",
    ogDescription: "Kosmetologė rekomenduoja: drėkinantis kremas, prieš raukšlių kremas, veido serumas ir kiti profesionalūs grožio produktai. Pristatymas visoje Lietuvoje.",
    twitterDescription: "Kosmetologė rekomenduoja: drėkinantis kremas, serumas, prieš raukšlių priemonės. Pristatymas visoje Lietuvoje.",
  },

  // Cookie Policy
  cookiePolicy: {
    title: "Slapukų (angl. \"cookies\") politika",
    description: "Ši politika yra paaiškinimas, kaip naudojami slapukai mūsų svetainėje beaubox.lt",
    lastUpdate: "Paskutinis atnaujinimas:",
    effectiveDate: "Įsigalioja:",
    date: "2024 m. sausis",
    effectiveDateValue: "2024 m. sausio 15 d.",
    
    whatAreCookies: {
      title: "Kas yra slapukai?",
      paragraph1: "Slapukai (angl. \"cookies\") – tai maži tekstiniai failai, kuriuos svetainės išsaugo jūsų kompiuteryje ar mobiliajame įrenginyje, kai lankotės svetainėje. Slapukai padeda svetainei \"atsiminti\" jūsų veiksmus ir nuostatas (pvz., prisijungimo duomenis, kalbą, šrifto dydį ir kitas rodymo nuostatas) tam tikrą laiką.",
      paragraph2: "Slapukai nekenks jūsų kompiuteriui ir negali perduoti virusų. Jie yra saugūs ir plačiai naudojami visose šiuolaikinėse svetainėse siekiant pagerinti naudotojo patirtį."
    },
    
    cookieTypes: {
      title: "Kokius slapukus naudojame?",
      essential: "Būtini slapukai",
      functional: "Funkciniai slapukai",
      analytical: "Analitiniai slapukai",
      marketing: "Rinkodaros slapukai",
      canDisable: "Galima išjungti",
      required: "Būtina",
      purpose: "Paskirtis:",
      examples: "Pavyzdžiai:",
      retention: "Saugojimo laikas:",
      legalBasis: "Teisinis pagrindas:",
      
      essentialPurpose: "Reikalingi svetainės veikimui",
      essentialExamples: "Prisijungimo sesijos, krepšelio turinys, saugumo nustatymai",
      essentialRetention: "Sesijos metu arba iki 30 dienų",
      essentialLegal: "Teisėtas interesas (BDAR 6 str. 1 d. f punktas)",
      
      functionalPurpose: "Pagerina svetainės funkcionalumą",
      functionalExamples: "Kalbos nustatymai, regiono pasirinkimas, dizaino nuostatos",
      functionalRetention: "Iki 12 mėnesių",
      functionalLegal: "Sutikimas (BDAR 6 str. 1 d. a punktas)",
      
      analyticalPurpose: "Padeda suprasti, kaip naudojate svetainę",
      analyticalExamples: "Google Analytics, puslapių peržiūros, lankytojų elgsena",
      analyticalRetention: "Iki 26 mėnesių",
      analyticalLegal: "Sutikimas (BDAR 6 str. 1 d. a punktas)",
      
      marketingPurpose: "Naudojami reklamos personalizavimui",
      marketingExamples: "Facebook Pixel, Google Ads, retargeting",
      marketingRetention: "Iki 13 mėnesių",
      marketingLegal: "Sutikimas (BDAR 6 str. 1 d. a punktas)"
    },
    
    thirdParty: {
      title: "Trečiųjų šalių paslaugos",
      description: "Naudojame šių trečiųjų šalių paslaugas, kurios gali nustatyti savo slapukus:",
      googleAnalytics: "Google Analytics",
      googleAnalyticsPurpose: "Svetainės statistikos rinkimas",
      googleAnalyticsData: "IP adresas (anonimizuotas), puslapių peržiūros, įrenginio informacija",
      facebookPixel: "Facebook Pixel",
      facebookPixelPurpose: "Reklamos efektyvumo matavimas",
      facebookPixelData: "Puslapių peržiūros, pirkimo veiksmai, IP adresas",
      supabase: "Supabase",
      supabasePurpose: "Duomenų bazės ir autentifikacijos paslaugos",
      supabaseData: "Naudotojo duomenys, sesijos informacija",
      dataShared: "Dalijamasi duomenimis:",
      privacyPolicy: "Privatumo politika →"
    },
    
    management: {
      title: "Kaip valdyti slapukus?",
      websiteSettings: "Svetainės nustatymai",
      websiteSettingsText: "Galite valdyti savo slapukų nuostatas bet kuriuo metu paspausdami \"Slapukų nustatymai\" mygtuką svetainės apačioje arba kreipkitės į mus el. paštu.",
      websiteSettingsNote: "Pastaba: išjungus būtinus slapukus, kai kurios svetainės funkcijos gali neveikti tinkamai.",
      browserSettings: "Naršyklės nustatymai",
      browserSettingsText: "Taip pat galite valdyti slapukus tiesiogiai savo naršyklės nustatymuose:",
      chrome: "Nustatymai → Privatumas ir sauga → Slapukai",
      firefox: "Nustatymai → Privatumas ir sauga → Slapukai ir svetainės duomenys",
      safari: "Nustatymai → Privatumas → Slapukų tvarkymas",
      edge: "Nustatymai → Slapukai ir svetainės leidimai"
    },
    
    gdprRights: {
      title: "Jūsų teisės pagal BDAR",
      rightToInfo: "Teisė į informaciją",
      rightToInfoText: "Turite teisę žinoti, kokie duomenys apie jus renkami ir kaip jie naudojami.",
      rightToAccess: "Teisė į prieigą",
      rightToAccessText: "Galite prašyti gauti kopiją visų apie jus tvarkomų asmens duomenų.",
      rightToWithdraw: "Teisė į atšaukimą",
      rightToWithdrawText: "Galite bet kuriuo metu atšaukti savo sutikimą dėl slapukų naudojimo.",
      rightToErasure: "Teisė į ištrynimą",
      rightToErasureText: "Galite prašyti ištrinti visus apie jus surinktus duomenis."
    },
    
    contact: {
      title: "Duomenų valdytojas ir kontaktai",
      dataController: "Duomenų valdytojas:",
      companyName: "\"BeauBox\"",
      companyCode: "Įmonės kodas: __________",
      vatCode: "PVM mokėtojo kodas: LT___________",
      address: "Adresas:",
      email: "El. paštas: duomenys@beaubox.lt",
      dpoTitle: "Duomenų apsaugos pareigūnas:",
      dpoEmail: "El. paštas: info@beaubox.lt",
      dpoPhone: "Telefonas:",
      complaints: "Skundai:",
      complaintsText: "Jei manote, kad jūsų teisės pažeistos, galite kreiptis į:",
      inspectionName: "Valstybinė duomenų apsaugos inspekcija",
      inspectionContact: "www.ada.lt | ada@ada.lt"
    },
    
    updates: {
      title: "Politikos keitimai",
      paragraph1: "Šią slapukų politiką galime keisti, kad ji atitiktų naujus teisės aktus, technologijų pokyčius ar mūsų veiklos poreikius. Apie esminius pakeitimus informuosime el. paštu arba paskelbdami pranešimą svetainėje.",
      paragraph2: "Rekomenduojame reguliariai peržiūrėti šią politiką, kad būtumėte informuoti apie tai, kaip saugome ir naudojame jūsų duomenis."
    }
  },
  
  // Contact
  contact: {
    pageTitle: 'Susisiekite su mumis',
    subtitle: 'Turite klausimų apie produktus ar reikia pagalbos? Mūsų komanda visada pasiruošusi jums padėti.',
    formTitle: 'Parašykite mums',
    formDesc: 'Užpildykite formą ir mes susisieksime su jumis per 24 valandas',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    email: 'El. paštas',
    phoneOptional: 'Telefonas (neprivaloma)',
    subject: 'Tema',
    subjectPlaceholder: 'Klausimas apie produktą',
    message: 'Žinutė',
    messagePlaceholder: 'Parašykite savo klausimą ar komentarą...',
    send: 'Siųsti žinutę',
    sending: 'Siunčiama...',
    sentTitle: 'Žinutė išsiųsta!',
    sentDesc: 'Ačiū už jūsų žinutę. Susisieksime su jumis per 24 valandas.',
    errorTitle: 'Klaida',
    errorDesc: 'Nepavyko išsiųsti žinutės. Bandykite dar kartą arba susisiekite telefonu.',
    contactInfoTitle: 'Kontaktinė informacija',
    phoneLabel: 'Telefonas',
    emailLabel: 'El. paštas',
    addressLabel: 'Adresas',
    workingHours: 'Darbo laikas',
    monFri: 'Pr–Pt: 9:00 - 18:00',
    sat: 'Št: 10:00 - 16:00',
    sun: 'Sk: Nedirbame',
    faqTitle: 'DUK',
    faqDesc: 'Greiti atsakymai į dažniausius klausimus',
    shippingQuestion: 'Kiek kainuoja pristatymas?',
    returnsQuestion: 'Kaip grąžinti produktą?',
    originalQuestion: 'Ar produktai originalūs?',
    more: 'Daugiau',
    consultBannerTitle: 'Konsultacijos užklausa',
    consultBannerDesc: 'Forma užpildyta automatiškai su jūsų duomenimis ir produktų informacija',
    consultSubject: 'Konsultacija dėl produktų, reikalaujančių konsultacijos',
    consultHello: 'Sveiki,',
    consultNoItemsBody: 'Norėčiau gauti konsultaciją dėl produktų, kuriems reikalinga specialistų rekomendacija.',
    consultWithItemsIntro: 'Norėčiau gauti konsultaciją dėl šių produktų, kurie yra mano krepšelyje:',
    consultSuffix: 'Prašau susisiekti su manimi, kad galėčiau užbaigti pirkimą.\n\nAčiū!',
  },

  // Pristatymo puslapis
  delivery: {
    pageTitle: 'Pristatymas ir mokėjimas',
    pageSubtitle: 'Visa informacija apie užsakymo pristatymą Lietuvoje',
    deliveryMethods: 'Pristatymo būdai',
    standardDelivery: 'Standartinis pristatymas',
    standardDeliveryTime: '2-3 darbo dienos',
    omnivaLockers: 'Omniva paštomatai',
    omnivaTime: '1-3 darbo dienos',
    freeFrom: 'Nemokamai nuo',
    paymentMethods: 'Mokėjimo būdai',
    bankCard: 'Banko kortelė (Visa, Mastercard)',
    bankTransfer: 'Banko pavedimas',
    cashOnDelivery: 'Mokėjimas gavus (kurjerių pristatymas)',
    securePayment: 'Visi mokėjimai yra saugūs ir šifruojami SSL apsauga',
    yourRights: 'Jūsų teisės',
    returnRight: 'Grąžinimo teisė',
    returnRightDesc: '14 dienų grąžinimo terminas pagal LR VTĮ apsaugos įstatymą',
    warranty: 'Garantija',
    warrantyDesc: '2 metų kokybės garantija visiems produktams',
    complaints: 'Reklamacijos',
    complaintsDesc: 'Nemokamos prekių reklamacijos per garantijos laikotarpį',
    dataProtection: 'Duomenų apsauga',
    dataProtectionDesc: 'Jūsų duomenys saugomi pagal BDAR reikalavimus',
    detailedTerms: 'Detalūs pristatymo nuostatai',
    detailedTermsDesc: 'Visokeriopą informaciją apie užsakymo apdorojimą ir pristatymą',
    orderProcessing: 'Užsakymo apdorojimas',
    orderProcessing1: 'Užsakymai priimami 24/7 internetu',
    orderProcessing2: 'Darbo dienomis užsakymai apdorojami iki 17:00',
    orderProcessing3: 'Savaitgaliais ir švenčių dienomis užsakymai apdorojami kitą darbo dieną',
    orderProcessing4: 'Užsakymo patvirtinimas siunčiamas el. paštu',
    orderProcessing5: 'Pristatymo informacija siunčiama SMS žinute arba el. paštu',
    deliveryZones: 'Pristatymo zonos',
    allCities: 'Visi Lietuvos miestai:',
    allCitiesTime: '1-3 darbo dienos',
    ruralAreas: 'Kaimo vietovės:',
    ruralAreasTime: '1-5 darbo dienos',
    deliveryAllLithuania: 'Pristatome visoje Lietuvos teritorijoje',
    importantInfo: 'Svarbi informacija',
    attention: 'Dėmesio:',
    attentionText: 'Kosmetikos produktai yra trapūs. Pristatymo metu būtinai patikrinkite pakuotės vientisumą.',
    guarantee: 'Garantija:',
    guaranteeText: 'Jei produktas pažeistas pristatymo metu, nedelsiant susisiekite su mumis.',
    contactForDelivery: 'Kontaktai pristatymo klausimais',
    workingHours: 'Pr-Pt: 8:00-17:00',
  },

  // Grąžinimo puslapis
  returns: {
    pageTitle: 'Prekių grąžinimas ir keitimas',
    pageSubtitle: 'Visa informacija apie prekių grąžinimą pagal Lietuvos Respublikos vartotojų teisių apsaugos įstatymą',
    days14: '14 dienų',
    days14Desc: 'Grąžinimo terminas nuo prekės gavimo dienos',
    fullRefund: 'Pilnas grąžinimas',
    fullRefundDesc: 'Grąžiname visą sumą per 14 dienų',
    originalCondition: 'Originali būklė',
    originalConditionDesc: 'Prekė turi būti nepažeista ir originalioje pakuotėje',
    returnProcess: 'Grąžinimo procesas',
    returnProcessDesc: 'Paprastas 4 žingsnių grąžinimo procesas',
    step1Title: 'Susisiekite su mumis',
    step1Desc: 'Parašykite el. laišką arba paskambinkite nurodytu telefonu',
    step2Title: 'Gaukite grąžinimo kodą',
    step2Desc: 'Mes atsiųsime grąžinimo numerį ir instrukcijas',
    step3Title: 'Išsiųskite prekę',
    step3Desc: 'Supakuokite prekę ir išsiųskite mūsų nurodytu adresu',
    step4Title: 'Gaukite pinigus',
    step4Desc: 'Pinigai bus grąžinti per 14 dienų nuo prekės gavimo',
    startReturn: 'Pradėti grąžinimą',
    returnConditions: 'Grąžinimo sąlygos',
    returnConditionsDesc: 'Kada galite grąžinti prekes',
    undamagedProduct: 'Nepažeista prekė',
    undamagedProductDesc: 'Prekė turi būti originalioje būklėje',
    originalPackaging: 'Originali pakuotė',
    originalPackagingDesc: 'Su visais etikečių ir pakuotės elementais',
    days14Term: '14 dienų terminas',
    days14TermDesc: 'Nuo prekės gavimo dienos',
    purchaseDocument: 'Pirkimo dokumentas',
    purchaseDocumentDesc: 'Užsakymo numeris arba sąskaita',
    exceptions: 'Išimtys',
    exception1: 'Atidaryta kosmetika (higienos sumetimais)',
    exception2: 'Individualizuoti produktai',
    exception3: 'Pažeista ar nešvari prekė',
    exception4: 'Prekės, kurios gali greitai sugesti',
    legalInfo: 'Teisinė informacija',
    legalInfoDesc: 'Pagal Lietuvos Respublikos vartotojų teisių apsaugos įstatymą',
    yourRights: 'Jūsų teisės kaip vartotojo',
    right1: '14 dienų grąžinimo teisė - galite grąžinti prekę be priežasties nurodymo',
    right2: 'Pinigų grąžinimas per 14 dienų nuo mūsų gavus grąžintą prekę',
    right3: 'Prekės keitimas į kitą dydį, spalvą ar modelį',
    right4: 'Nemokamas grąžinimas jei prekė nekokybiška ar pažeista',
    right5: 'Garantinis remontas arba keitimas per 2 metus',
    ourCommitments: 'Mūsų įsipareigojimai',
    commitment1: 'Greitai reaguojame - atsakome per 24 valandas',
    commitment2: 'Keičiame prekes nemokamai esant gamintojo defektui',
    commitment3: 'Teikiame konsultacijas dėl prekių naudojimo',
    importantProvisions: 'Svarbūs nuostatai',
    provision1: 'Grąžinimo teisė galioja 14 kalendorinių dienų nuo prekės gavimo',
    provision2: 'Grąžinimo išlaidos tenka pirkėjui, išskyrus atvejus, kai prekė yra nekokybiškai',
    provision3: 'Pinigai grąžinami tuo pačiu būdu, kuriuo buvo apmokėta',
    provision4: 'Kosmetikos produktai grąžinami tik esant kokybės defektui',
    provision5: 'Dėl ginčų kreipkitės į Valstybinę vartotojų teisių apsaugos tarnybą',
    contactTitle: 'Kontaktai grąžinimo klausimais',
    contactDesc: 'Susisiekite su mumis bet kuriuo patogiu būdu',
    returnEmail: 'El. paštas grąžinimams',
    phone: 'Telefonas',
    workingHours: 'Darbo laikas',
    workingHoursTime: 'Pr-Pt: 9:00-17:00',
    returnAddress: 'Grąžinimo adresas',
    addressWarning: 'Prieš siųsdami prekę, būtinai susisiekite su mumis ir gaukite grąžinimo kodą!',
    important: 'Svarbu:',
    gmailOpened: 'Gmail atidaryta naujame lange',
    gmailDesc: 'Užpildykite prašymą ir išsiųskite mums grąžinimo užklausą.',
    emailSubject: 'Prekės grąžinimo prašymas',
    emailBody: 'Sveiki,\n\nNoriu pradėti prekės grąžinimo procesą.\n\nUžsakymo numeris: [Jūsų užsakymo numeris]\nPrekės pavadinimas: [Prekės pavadinimas]\nGrąžinimo priežastis: [Jūsų priežastis]\n\nPrašau atsiųsti grąžinimo kodą ir instrukcijas.\n\nAčiū!',
  },

  // DUK puslapis
  faq: {
    title: 'Dažniausiai užduodami klausimai',
    description: 'Čia rasite atsakymus į dažniausius klausimus apie mūsų produktus, pristatymą, mokėjimą ir grąžinimą. Neradote atsakymo? Susisiekite su mumis!',
    contactTitle: 'Neradote atsakymo į savo klausimą?',
    contactDescription: 'Mūsų klientų aptarnavimo komanda mielai jums padės. Susisiekite su mumis bet kuriuo patogiu būdu.',
    email: 'El. paštas',
    emailSubtitle: 'Atsakome per 24 val.',
    phone: 'Telefonas',
    phoneSubtitle: 'I-V 9:00-18:00',
    directHelp: 'Tiesioginė pagalba',
    directHelpSubtitle: 'Greitas atsakymas',
    contactPage: 'Kontaktų puslapis',
    categories: {
      orders: 'Užsakymai ir pristatymas',
      products: 'Produktai ir kokybė',
      payment: 'Mokėjimas ir sąskaitos',
      returns: 'Grąžinimas ir mainai',
      account: 'Paskyra ir lojalumas',
    },
    questions: {
      deliveryTime: 'Kiek laiko užtrunka pristatymas?',
      deliveryTimeAnswer: 'Standartinis pristatymas užtrunka 1-3 darbo dienas Lietuvoje. Skubūs užsakymai gali būti pristatyti per 24 valandas už papildomą mokestį.',
      freeShipping: 'Koks yra minimalus užsakymo dydis nemokamam pristatymui?',
      freeShippingAnswer: 'Nemokamas pristatymas taikomas užsakymams nuo {threshold} €. Mažesniems užsakymams taikomas {cost} € pristatymo mokestis.',
      changeOrder: 'Ar galiu keisti ar atšaukti savo užsakymą?',
      changeOrderAnswer: 'Užsakymą galite keisti ar atšaukti per 1 valandą nuo jo pateikimo, jei jis dar nebuvo paruoštas siuntimui. Susisiekite su mumis telefonu arba el. paštu.',
      deliveryMethods: 'Kokie pristatymo būdai galimi?',
      deliveryMethodsAnswer: 'Pristatome į Omniva paštomatus, pašto siuntomis bei kurjerių tarnybos pagalba tiesiai į namus ar biurą.',
      originalProducts: 'Ar visi produktai yra originalūs?',
      originalProductsAnswer: 'Taip, mes parduodame tik originalius produktus, tiesiogiai įsigytus iš oficialių gamintojų atstovų ar pačių gamintojų.',
      skinType: 'Kaip žinoti, kuris produktas tinka mano odos tipui?',
      skinTypeAnswer: 'Kiekvieno produkto aprašyme nurodomas tinkamas odos tipas. Taip pat galite susisiekti su konsultantais.',
      samples: 'Ar galiu gauti produkto mėginį prieš pirkdama?',
      samplesAnswer: 'Taip, kai kuriems produktams turime mėginių. Jie pridedami prie užsakymo nemokamai arba galite juos atskirai užsisakyti mūsų svetainėje.',
      expiry: 'Koks produktų galiojimo laikas?',
      expiryAnswer: 'Visi produktai parduodami su ne mažiau kaip 6 mėnesių galiojimo laiku. Tikslus galiojimo laikas nurodytas ant kiekvieno produkto pakuotės.',
      paymentMethods: 'Kokie mokėjimo būdai priimami?',
      paymentMethodsAnswer: 'Priimame mokėjimus banko kortelėmis (Visa, Mastercard), internetinio banko pavedimais, Paysera ir mokėjimą gavus prekes.',
      installments: 'Ar galiu mokėti dalimis?',
      installmentsAnswer: 'Ne',
      paymentTiming: 'Kada nuskaičiuojami pinigai už užsakymą?',
      paymentTimingAnswer: 'Mokant kortele pinigai nuskaičiuojami iš karto po užsakymo patvirtinimo. Mokant banko pavedimu - kai gauname mokėjimą.',
      invoice: 'Ar galiu gauti sąskaitą faktūrą?',
      invoiceAnswer: 'Taip, registruotoms įmonėms išrašome sąskaitas faktūras. Nurodykite įmonės duomenis užsakymo metu.',
      returnPeriod: 'Per kiek laiko galiu grąžinti produktą?',
      returnPeriodAnswer: 'Produktus galite grąžinti per 14 kalendorinių dienų nuo gavimo, jei jie nenaudoti ir originalios pakuotės.',
      nonReturnable: 'Kokie produktai negali būti grąžinami?',
      nonReturnableAnswer: 'Dėl higienos sumetimų negalime priimti grąžinti atplėštų ar naudotų produktų, ypač lūpų dažų, maskų ir akių makiažo priemonių.',
      returnCosts: 'Kas apmoka grąžinimo išlaidas?',
      returnCostsAnswer: 'Jei produktas grąžinamas dėl mūsų kaltės (klaidingi duomenys, defektas), mes apmokame grąžinimo išlaidas. Kitais atvejais - pirkėjas.',
      returnProcess: 'Kaip grąžinti produktą?',
      returnProcessAnswer: 'Susisiekite su mumis el. paštu arba telefonu, nurodykite užsakymo numerį ir grąžinimo priežastį. Išsiųsime grąžinimo instrukcijas.',
      benefits: 'Kokios naudos turi registruoti vartotojai?',
      benefitsAnswer: 'Registruoti naudotojai gauna specialius pasiūlymus, sukaupti lojalumo taškus, gali sekti užsakymų istoriją ir greičiau pildyti užsakymus.',
      loyaltyProgram: 'Kaip veikia lojalumo programa?',
      loyaltyProgramAnswer: 'Už kiekvieną išleistą eurą gaunate 0.01 lojalumo tašką. 1 taškas = 1 € nuolaida kitam užsakymui.',
      editAccount: 'Ar galiu keisti savo paskyros duomenis?',
      editAccountAnswer: 'Taip, prisijungę prie savo paskyros galite redaguoti asmens duomenis, pristatymo adresus ir mokėjimo informaciją.',
      resetPassword: 'Kaip atkurti pamirštą slaptažodį?',
      resetPasswordAnswer: 'Prisijungimo puslapyje spauskite "Pamiršau slaptažodį" ir įveskite savo el. pašto adresą. Atsiųsime nuorodą slaptažodžio atkūrimui.',
    },
  },

  // Krepšelis
  cart: {
    title: 'Jūsų krepšelis',
    items: 'prekės',
    item: 'prekė',
    empty: 'Jūsų krepšelis tuščias',
    emptyDescription: 'Pradėkite apsipirkimą ir atraskite puikius produktus',
    continueShopping: 'Tęsti apsipirkimą',
    preparingOrder: 'Ruošiamas užsakymas...',
    loading: 'Kraunama...',
    freeDelivery: 'Nemokamas pristatymas',
    delivery: 'Pristatymas',
    securePayment: 'Saugus mokėjimas',
    qualityGuarantee: 'Kokybės garantija',
    consultationRequired: 'Reikalinga konsultacija',
    consultationProvided: 'Konsultacija suteikta',
    each: 'kiekvienai',
    consultationWarningTitle: 'Krepšelyje yra prekių, kurioms reikalinga konsultacija',
    consultationWarningDesc: 'Mokėjimas bus negalimas. Susisiekite su mumis dėl šių prekių konsultacijos.',
    itemsValue: 'Prekių vertė:',
    deliveryLabel: 'Pristatymas:',
    free: 'Nemokamas',
    total: 'Viso mokėti:',
    paymentUnavailable: 'Mokėjimas negalimas',
    buyNow: 'Pirkti dabar',
    contactForConsultation: 'Susisiekti dėl konsultacijos',
    updateCart: 'Atnaujinti krepšelį',
    clearCart: 'Išvalyti krepšelį',
    sslProtection: '256-bit SSL apsauga • Saugus mokėjimas',
    addedToCart: 'Pridėta į krepšelį',
    productAddedToCart: 'pridėta į krepšelį',
    viewCart: 'Žiūrėti krepšelį',
  },

  // About
  about: {
    heading: "Apie BeauBox",
    intro: "– tai ne tik grožio produktų parduotuvė, tai tikras grožio pasaulis, kuriame susitinka išskirtiniai prekių ženklai.",
    mission: "Mūsų misija – padėti kiekvienai moteriai atrasti savo unikalų grožio ritualą. Mes ne tik parduodame produktus, bet ir kuriame istorijas, mokom, įkvepiame ir palydime grožio kelionėje.",
    quality: "Kiekvienas mūsų siūlomas produktas yra kruopščiai atrinktas, išbandytas ir aprobuotas specialistų komandos. Mes tikime, kad grožis prasideda nuo sveikos odos ir teisingo produktų pasirinkimo.",
    features: {
      premiumQuality: {
        title: "Premium kokybė",
        description: "Atrenkami tik aukščiausios kokybės produktai iš patikimų tiekėjų"
      },
      expertAdvice: {
        title: "Ekspertų patarimai",
        description: "Kiekvienas produktas rekomenduojamas sertifikuotų kosmetologų"
      },
      naturalIngredients: {
        title: "Natūralūs ingredientai",
        description: "Pirmenybė teikiama gamtos kilmės ir ekologiškiems produktams"
      },
      individualProgram: {
        title: "Individuali programa",
        description: "Kuriame unikalų grožio kompleksą kiekvienam odos tipui"
      }
    }
  },

  // Products
  products: {
    title: 'Mūsų produktai',
    description: 'Atskleiskite savo grožį su mūsų kruopščiai atrinktais produktais, skirtais kiekvienam odos tipui ir poreikiui.',
    filters: 'Produktų filtrai',
    clearFilters: 'Išvalyti filtrus',
    category: 'Kategorija',
    selectCategory: 'Pasirinkite kategoriją',
    skinType: 'Odos tipas',
    selectSkinType: 'Pasirinkite odos tipą',
    brand: 'Prekių ženklas',
    allBrands: 'Visi prekių ženklai',
    allPurposes: 'Visi',
    purpose: 'Paskirtis',
    all: 'Visi',
    priceRange: 'Kainų diapazonas',
    activeFilters: 'Aktyvūs filtrai:',
    removeFilter: 'Pašalinti filtrą',
    found: 'Rasta',
    productsCount: 'produktų',
    allProducts: 'Visi produktai',
    allSkinTypes: 'Visi odos tipai',
    badges: {
      new: 'Nauja',
      popular: 'Populiaru',
      recommended: '★ Kosmetologų rekomenduojama',
      consultationRequired: 'Reikalinga konsultacija',
      bestseller: '🔥 Bestseller',
      recommendedShort: '★ Rekomenduojama',
    },
    buttons: {
      addToWishlist: 'Pridėti į norų sąrašą',
      quickView: 'Greitas peržiūrėjimas',
      addToCart: 'Į krepšelį',
      buy: 'Pirkti',
      contactForConsultation: 'Susisiekti dėl konsultacijos',
    },
    reviewsCount: 'atsiliepimai',
    stockUrgency: 'Tik {count} vnt. likę!',
    saveAmount: 'Sutaupote €{amount}',
    loginToSeePrice: 'Prisijunkite norėdami matyti kainą',
    viewAllProducts: 'Žiūrėti visus produktus',
  },

  // Wishlist
  wishlist: {
    title: 'Norų sąrašas',
    items: 'prekės',
    item: 'prekė',
    empty: 'Jūsų norų sąrašas tuščias',
    emptyDescription: 'Pridėkite produktus, kurie jums patinka ir grįžkite prie jų vėliau',
    discoverProducts: 'Atrasti produktus',
    featuredTitle: 'Jūsų įdomiausi produktai',
    featuredDescription: 'Įsigykite juos dabar ir mėgaukitės ypatingais pasiūlymais',
    addToCart: 'Į krepšelį',
    view: 'Žiūrėti',
    totalProducts: 'Viso produktų:',
    addAllToCart: 'Pridėti viską į krepšelį',
    continueShopping: 'Tęsti apsipirkimą',
    savedToProfile: 'Saugoma jūsų profilyje',
  },

  // Checkout
  checkout: {
    title: 'Užsakymo informacija',
    userInfo: 'Vartotojo informacija',
    companyInfo: 'Įmonės informacija',
    deliveryInfo: 'Pristatymo informacija',
    paymentMethod: 'Mokėjimo būdas',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    email: 'El. paštas',
    phone: 'Telefonas',
    companyCode: 'Įmonės kodas',
    companyVatCode: 'PVM mokėtojo kodas',
    optional: 'neprivaloma',
    fillIfCompany: 'Užpildykite, jei perkate įmonei',
    deliveryMethod: 'Pristatymo būdas',
    homeDelivery: 'Pristatymas į namus',
    homeDeliveryDesc: 'Kurjerio pristatymas į nurodytą adresą',
    parcelMachine: 'Omniva paštomatas',
    parcelMachineDesc: 'Paėmimas iš pasirinkto paštomato',
    salonPickup: 'Atsiėmimas salone',
    salonPickupDesc: 'Nemokamas atsiėmimas pasirinktoje vietoje',
    address: 'Adresas',
    addressPlaceholder: 'Gatvės pavadinimas ir namo numeris',
    city: 'Miestas',
    cityPlaceholder: 'Miestas',
    postalCode: 'Pašto kodas',
    postalCodePlaceholder: '12345',
    selectParcelMachine: 'Pasirinkite paštomatą',
    selectParcelMachineError: 'Prašome pasirinkti paštomatą pristatymui',
    selectSalon: 'Pasirinkite atsiėmimo vietą',
    selectSalonError: 'Prašome pasirinkti saloną atsiėmimui',
    paymentMethodTitle: 'Mokėjimo būdas',
    paymentMethodDesc: 'Pasirinkite patogų mokėjimo būdą',
    cardPayment: 'Banko kortelė',
    cardPaymentDesc: 'Greitas ir saugus mokėjimas',
    popular: 'Populiariausias',
    instantPayment: 'Momentinis mokėjimas',
    pciSecurity: 'PCI DSS saugumas',
    payseraPayment: 'Paysera banko pavedimas',
    payseraPaymentDesc: 'Mokėjimas per internetinę bankininkystę',
    securePayment: 'Saugus mokėjimas',
    allBanks: 'Visos bankai',
    cashOnDelivery: 'Mokėjimas gavus',
    cashOnDeliveryDesc: 'Mokėkite pristatymo metu',
    additionalFee: 'Papildomas mokestis',
    cashOnly: 'Tik grynaisiais',
    bankTransfer: 'Banko pavedimas',
    bankTransferDesc: 'Perveskite iš savo banko',
    processing: '1-2 darbo dienų apdorojimas',
    additionalInstructions: 'Jokių papildomų mokesčių',
    cardholderDetails: 'Kortelės duomenys',
    cardholderName: 'Vardas',
    cardholderLastName: 'Pavardė',
    orderSummary: 'Užsakymo santrauka',
    itemsValue: 'Prekių vertė',
    discount: 'Nuolaida',
    loyaltyDiscount: 'Lojalumo nuolaida',
    shipping: 'Pristatymas',
    free: 'Nemokamas',
    total: 'Viso mokėti',
    placeOrder: 'Pateikti užsakymą',
    processingButton: 'Apdorojama...',
    secureCheckout: '256-bit SSL apsauga • Saugus mokėjimas',
    loginRequired: 'Prisijunkite prie paskyros',
    loginRequiredDesc: 'Norint pateikti užsakymą, reikia prisijungti prie paskyros arba susikurti naują.',
    loginRegister: 'Prisijungti / Registruotis',
    backToStore: 'Grįžti į parduotuvę',
    processingOrder: 'Apdorojamas užsakymas...',
    processingOrderDesc: 'Prašome palaukti, ruošiame jūsų užsakymą',
    orderReceived: 'Užsakymas priimtas!',
    orderReceivedDesc: 'Dėkojame už jūsų užsakymą. Netrukus gausite patvirtinimo el. laišką.',
    orderNumber: 'Užsakymo numeris:',
    emptyCart: 'Krepšelis tuščias',
    emptyCartDesc: 'Pridėkite produktų į krepšelį prieš perkant.',
    shop: 'Apsipirkti',
    paymentBlocked: 'Mokėjimas negalimas',
    paymentBlockedDesc: 'Jūsų krepšelyje yra prekių, kurioms reikalinga konsultacija prieš pirkimą. Mokėjimo procesas yra blokuojamas saugumo sumetimais. Prašome susisiekti su mumis dėl konsultacijos.',
    contactForConsultation: 'Susisiekti dėl konsultacijos',
    loyaltyPoints: 'Lojalumo taškai',
    availablePoints: 'Jūsų turimi taškai:',
    usePoints: 'Naudoti taškus',
    pointsToUse: 'Taškų naudoti:',
    useAllPoints: 'Panaudoti visus taškus',
    pointsValue: '1 taškas = 1€ nuolaida',
    youWillEarn: 'Už šį užsakymą gausite:',
    points: 'taškų',
    earnedAfterDiscount: '(skaičiuojama po nuolaidos)',
    minimumCharge: 'Minimalus mokestis: 0.01€ už vienetą',
    consultationRequired: 'Reikalinga konsultacija',
    consultationApproved: 'Konsultacija suteikta',
    consultationRequiredTitle: 'Konsultacija reikalinga',
    consultationRequiredDesc: 'Jūsų krepšelyje yra prekių, kurioms reikalinga konsultacija. Prašome susisiekti su mumis.',
    missingInfo: 'Trūksta informacijos',
    missingAddressDesc: 'Prašome užpildyti visus pristatymo adreso laukus',
    loadingSettings: 'Kraunama...',
    loadingSettingsDesc: 'Palaukite, kol įkeliami pristatymo nustatymai',
    paymentUnavailable: 'Mokėjimo sistema nepasiekiama',
    paymentUnavailableDesc: 'Mokėjimo sistema laikinai nepasiekiama. Bandykite vėliau arba susisiekite su mumis.',
    paymentError: 'Klaida',
    paymentErrorDesc: 'Nepavyko sukurti mokėjimo. Bandykite dar kartą.',
    noPaymentUrl: 'Nepavyko gauti mokėjimo nuorodos. Bandykite dar kartą.',
    popupBlocked: 'Iškylančių langų blokavimas',
    popupBlockedDesc: 'Prašome leisti iškylančius langus šiam puslapiui ir bandyti dar kartą.',
    paymentSessionCreated: 'Mokėjimo sesija sukurta',
    paymentSessionDesc: 'Mokėjimo langas atidarytas. Užbaikite mokėjimą naujame lange.',
    paymentSystemNotLoaded: 'Mokėjimo sistema dar neįkrauta. Bandykite dar kartą.',
    cardFieldNotFound: 'Kortelės duomenų laukas nerastas.',
    paymentConfirmError: 'Mokėjimo klaida',
    paymentConfirmErrorDesc: 'Mokėjimas nepavyko. Patikrinkite kortelės duomenis.',
    paymentSuccess: 'Mokėjimas sėkmingas!',
    paymentSuccessDesc: 'Jūsų užsakymas buvo sėkmingai apmokėtas ir sukurtas.',
    backendError: 'Mokėjimas pavyko, bet užsakymo apdorojime įvyko klaida. Susisiekite su mumis.',
    orderCreated: 'Užsakymas sukurtas',
    orderCreatedDesc: 'Jūsų užsakymas sėkmingai pateiktas',
    parcelReserved: 'Paštomatas rezervuotas',
    parcelReservedDesc: 'Paštomatas sėkmingai rezervuotas. Sekimo numeris:',
    orderError: 'Nepavyko pateikti užsakymo. Bandykite dar kartą.',
    orderSuccessTitle: 'Užsakymas sėkmingai sukurtas!',
    orderSuccessDesc: 'Jūsų užsakymo numeris:',
    
    // Additional translations for checkout page
    companyInfoOptional: "Neprivaloma - užpildykite, jei perkate įmonei",
    parcelMachineRequired: "Prašome pasirinkti paštomatą pristatymui",
    salonRequired: "Prašome pasirinkti saloną atsiėmimui",
    selectPaymentMethod: "Pasirinkite patogų mokėjimo būdą",
    bankCard: "Banko kortelė",
    bankCardDesc: "Greitas ir saugus mokėjimas",
    mostPopular: "Populiariausias",
    payseraBankTransfer: "Paysera banko pavedimas",
    payseraDesc: "Mokėjimas per internetinę bankininkystę",
    noAdditionalFees: "Jokių papildomų mokesčių",
    cardDetails: "Kortelės duomenys",
    cardFirstName: "Vardas",
    cardLastName: "Pavardė",
    paymentSecurityInfo: "Mokėjimo duomenys apdorojami saugiai pagal PCI DSS standartus",
    loyaltyPointsTitle: "Lojalumo taškai",
    loyaltyPointsAvailable: "Turite {points} taškų. 1 taškas = €1 nuolaida",
    useLoyaltyPoints: "Naudoti lojalumo taškus",
    pointsAmount: "Taškų kiekis (maks. {max})",
    youWillSave: "✓ Sutaupysite: €{amount}",
    quantity: "Kiekis: {count}",
    priceAfterConsultation: "Kaina matoma po konsultacijos",
    perUnit: "per vnt.",
    consultationRequiredBadge: "Reikalinga konsultacija",
    consultationProvidedBadge: "Konsultacija suteikta",
    products: "Produktai:",
    loyaltyPointsDiscount: "Lojalumo taškų nuolaida (-{points} tšk.):",
    loyaltyPointsEarn: "🏆 Lojalumo taškai",
    earnPoints: "Užsakymu uždirbsite: +{points} taškų",
    addForFreeShipping: "Pridėkite prekių už €{amount} ir gaukite nemokamą pristatymą",
    orderSubmitted: "Užsakymas pateiktas",
    submitOrder: "Pateikti užsakymą"
  },

  // Quick Checkout
  quickCheckout: {
    title: 'Greitas pirkimas',
    description: 'Užbaikite užsakymą vienu paspaudimu naudodami išsaugotą kortelę',
    buyNow: 'Pirkti dabar',
    cancel: 'Atšaukti',
    deliveryMethod: 'Pristatymo būdas',
    paymentMethod: 'Mokėjimo būdas',
    savedCard: 'Išsaugota kortelė',
    newCard: 'Nauja kortelė',
    selectPaymentMethod: 'Pasirinkite mokėjimo metodą',
    itemPrice: 'Prekės kaina',
    shippingCost: 'Pristatymas',
    totalPrice: 'Viso',
    processing: 'Apdorojama...',
    loginRequired: 'Prašome prisijungti',
    loginRequiredDesc: 'Norint naudoti greitą pirkimą, reikia prisijungti',
    selectDeliveryMethod: 'Pasirinkite pristatymo būdą',
    selectParcelMachine: 'Pasirinkite paštomatą',
    selectSalon: 'Pasirinkite saloną',
    enterCardDetails: 'Įveskite kortelės duomenis',
    paymentSuccess: 'Mokėjimas sėkmingas!',
    paymentSuccessDesc: 'Jūsų užsakymas buvo sėkmingai sukurtas',
    paymentError: 'Mokėjimo klaida',
    paymentErrorDesc: 'Nepavyko apdoroti mokėjimo. Bandykite dar kartą.',
    orderCreated: 'Užsakymas sukurtas!',
    homeDelivery: 'Pristatymas į namus',
    parcelMachineDelivery: 'Pristatymas į paštomatą',
    salonPickup: 'Atsiėmimas salone',
    free: 'Nemokamas',
    cardDetails: 'Kortelės duomenys',
    productLabel: 'Prekė:',
    shippingLabel: 'Pristatymas:',
    totalLabel: 'Viso:',
    buyFor: 'Pirkti už',
    purchaseType: 'Pirkimo Tipas',
    oneTimePurchase: 'Vienkartinis Pirkimas',
    subscribeProduct: 'Prenumeruoti ir Sutaupyti',
    recurringPeriod: 'Atsiskaitymo Periodas',
    monthly: 'Kas mėnesį',
    yearly: 'Kasmet',
    save10: 'Sutaupyti 10%',
    subscriptionPrice: 'Prenumeratos Kaina',
    savings: 'Sutaupyta',
    subscribeNow: 'Prenumeruoti Dabar',
    redirecting: 'Nukreipiame į mokėjimo puslapį...',
    errors: {
      selectParcelMachine: 'Pasirinkite paštomatą',
      selectParcelMachineDesc: 'Prašome pasirinkti pristatymo paštomatą',
      selectSalon: 'Pasirinkite saloną',
      selectSalonDesc: 'Prašome pasirinkti atsiėmimo saloną',
      error: 'Klaida',
      paymentSystemNotLoaded: 'Mokėjimo sistema dar neįkrauta',
      cardElementNotFound: 'Kortelės duomenų laukas nerastas',
      clientSecretMissing: 'Negautas client_secret iš mokėjimo sistemos',
    },
  },

  // Omniva Parcel Machine Selector
  omniva: {
    label: 'Omniva paštomat',
    change: 'Keisti',
    selectTitle: 'Pasirinkite paštomatą',
    searchPlaceholder: 'Ieškoti pagal pavadinimą, miestą ar adresą...',
    loading: 'Kraunami paštomatai...',
    notFound: 'Paštomatų nerasta',
    emptyList: 'Paštomatų sąrašas tuščias',
    selectButton: 'Pasirinkti paštomatą',
    selectDescription: 'Spauskite, kad pasirinktumėte pristatymo paštomatą',
    error: 'Klaida',
    loadError: 'Nepavyko įkelti paštomatų sąrašo',
  },

  // Account Page
  account: {
    backToShop: 'Grįžti į parduotuvę',
    loyaltyPoints: 'lojalumo taškai',
    user: 'Vartotojas',
    
    // Tabs
    orders: 'Užsakymai',
    invoices: 'Sąskaitos',
    profile: 'Profilis',
    addresses: 'Adresai',
    settings: 'Nustatymai',
    
    // Invoices Section
    invoicesTitle: 'Sąskaitos faktūros',
    invoicesCount: 'sąskaitos',
    invoicesCountSingle: 'sąskaita',
    loadingInvoices: 'Kraunamos sąskaitos faktūros...',
    noInvoices: 'Sąskaitų faktūrų nėra',
    noInvoicesDescription: 'Jums dar neišrašyta jokių sąskaitų faktūrų.',
    loadInvoicesError: 'Nepavyko įkelti sąskaitų faktūrų',
    issueDate: 'Išrašyta',
    paymentTerm: 'Mokėjimo terminas',
    paymentTerms: 'Mokėjimo sąlygos',
    overdue: 'Pradelsta',
    downloadPdf: 'Atsisiųsti PDF',
    sendEmail: 'Siųsti el. paštu',
    preparing: 'Ruošiama...',
    sending: 'Siunčiama...',
    downloadSuccess: 'Sėkmingai atsisiųsta',
    downloadSuccessDesc: 'PDF sąskaita {invoiceNumber} atsisiųsta',
    downloadError: 'Nepavyko atsisiųsti sąskaitos faktūros',
    emailSent: 'El. laiškas išsiųstas',
    emailSentDesc: 'Sąskaita {invoiceNumber} išsiųsta į {email}',
    emailSendError: 'Nepavyko išsiųsti el. laiško',
    invoiceStatus: {
      draft: 'Juodraštis',
      sent: 'Išsiųsta',
      paid: 'Apmokėta',
      cancelled: 'Atšaukta',
    },
    
    // Orders Section
    myOrders: 'Mano užsakymai',
    ordersDescription: 'Peržiūrėkite savo užsakymų istoriją ir būsenas',
    loadingOrders: 'Kraunami užsakymai...',
    noOrders: 'Jūs dar neturite užsakymų',
    startShopping: 'Pradėti apsipirkimą',
    reorder: 'Užsakyti dar kartą',
    reorderSuccess: 'Prekės pridėtos į krepšelį',
    reorderSuccessDesc: 'Visos prieinamos prekės iš užsakymo buvo pridėtos į jūsų krepšelį.',
    reorderPartial: 'Kai kurios prekės neprieinamos',
    reorderPartialDesc: 'Dalis prekių nebepardavamos ir nebuvo pridėtos.',
    reorderFailed: 'Nepavyko pridėti prekių',
    reordering: 'Pridedama...',
    order: 'Užsakymas',
    products: 'produktai',
    product: 'produktas',
    details: 'Detalės',
    
    // Order Statuses
    status: {
      pending: 'Laukiama',
      confirmed: 'Patvirtintas',
      processing: 'Vykdomas',
      shipped: 'Išsiųstas',
      delivered: 'Pristatyta',
      cancelled: 'Atšauktas',
    },
    
    // Order Details Dialog
    orderDetails: 'Užsakymo detalės',
    orderInformation: 'Užsakymo informacija',
    orderNumber: 'Užsakymo numeris',
    number: 'Numeris',
    date: 'Data',
    time: 'Laikas',
    orderDate: 'Užsakymo data',
    orderStatus: 'Užsakymo būsena',
    totalAmount: 'Bendra suma',
    shippingCost: 'Pristatymo kaina',
    loyaltyPointsUsed: 'Panaudoti lojalumo taškai',
    paymentStatus: 'Mokėjimo būsena',
    paid: 'Apmokėta',
    pending: 'Laukiama',
    productQuantity: 'Produktų kiekis',
    totalWeight: 'Bendras svoris',
    orderProgress: 'Užsakymo būsena',
    deliveryMethod: 'Pristatymo būdas',
    deliveryAddress: 'Pristatymo adresas',
    deliveryInformation: 'Pristatymo informacija',
    deliveryAddressNotSpecified: 'Pristatymo adresas nenurodytas',
    recipient: 'Gavėjas',
    company: 'Įmonė',
    notSpecified: 'Nenurodyta',
    paymentMethod: 'Mokėjimo būdas',
    orderItems: 'Užsakymo produktai',
    quantity: 'Kiekis',
    unitPrice: 'Vieneto kaina',
    discount: 'Nuolaida',
    subtotal: 'Tarpinė suma',
    shipping: 'Pristatymas',
    total: 'Viso',
    orderedOn: 'Užsakytas',
    selectedSalon: 'Pasirinktas salonas',
    omnivaParcelMachine: 'Omniva paštomat',
    deliveryLocation: 'Pristatymo vieta',
    orderedProducts: 'Užsakyti produktai',
    orderSummary: 'Užsakymo santrauka',
    loyaltyPointsUsedLabel: 'Panaudoti lojalumo taškai',
    freeShipping: 'Nemokamas',
    likedOrder: 'Patiko užsakymas?',
    browseProducts: 'Naršykite mūsų naujausius grožio produktus',
    continueShopping: 'Tęsti apsipirkimą',
    
    // Delivery Methods
    delivery: {
      salonPickup: 'Atsiėmimas salone',
      salonPickupDesc: 'Produktai bus paruošti atsiėmimui salone',
      omnivaPickup: 'Omniva paštomate',
      omnivaPickupDesc: 'Pristatymas į pasirinktą Omniva paštomatą',
      standardDelivery: 'Standartinis pristatymas',
      standardDeliveryDesc: 'Pristatymas kurjeriu į nurodytą adresą',
      expressDelivery: 'Greitasis pristatymas',
      expressDeliveryDesc: 'Pristatymas per 1-2 darbo dienas',
      homeDelivery: 'Pristatymas į nurodytą adresą',
    },
    
    // Payment Methods
    payment: {
      card: 'Banko kortelė',
      cardDesc: 'Mokėjimas banko kortele',
      cash: 'Grynais pinigais',
      cashDesc: 'Mokėjimas grynaisiais pristatymo metu',
      bankTransfer: 'Banko pavedimas',
      bankTransferDesc: 'Mokėjimas banko pavedimu',
      mobilePayment: 'Mobilus mokėjimas',
      mobilePaymentDesc: 'Mokėjimas mobiliuoju telefonu',
      paysera: 'Paysera',
      payseraDesc: 'Mokėjimas per Paysera sistemą',
    },
    
    // Profile Section
    myProfile: 'Mano profilis',
    profileInformation: 'Profilio informacija',
    profileDescription: 'Valdykite savo asmens duomenis',
    updateYourPersonalInformation: 'Atnaujinkite savo asmeninę informaciją',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    email: 'El. paštas',
    phone: 'Telefonas',
    companyInformationOptional: 'Įmonės informacija (pasirinktinai)',
    companyCode: 'Įmonės kodas',
    companyVatCode: 'PVM mokėtojo kodas',
    optional: 'Neprivaloma',
    saveChanges: 'Išsaugoti pakeitimus',
    
    // Addresses Section
    shippingAddresses: 'Pristatymo adresai',
    addressesDescription: 'Valdykite savo pristatymo adresus',
    street: 'Gatvė',
    streetAndNumber: 'Gatvė ir namo numeris',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    saveAddress: 'Išsaugoti adresą',
    
    // Settings Section
    accountSettings: 'Paskyros nustatymai',
    settingsDescription: 'Tvarkykite savo paskyros nustatymus ir saugumą',
    passwordChange: 'Slaptažodžio keitimas',
    emailPreferences: 'El. pašto prenumeratos',
    newsletter: 'Gauti naujienlaiškius',
    newsletterDesc: 'Gaukite naujausias naujienas ir pasiūlymus',
    specialOffers: 'Gauti specialius pasiūlymus',
    specialOffersDesc: 'Gaukite informaciją apie akcijas ir nuolaidas',
    productRecommendations: 'Gauti produktų rekomendacijas',
    productRecommendationsDesc: 'Gaukite asmeninius produktų pasiūlymus',
    changePassword: 'Keisti slaptažodį',
    currentPassword: 'Dabartinis slaptažodis',
    newPassword: 'Naujas slaptažodis',
    confirmPassword: 'Pakartokite naują slaptažodį',
    updatePassword: 'Keisti slaptažodį',
    savePreferences: 'Išsaugoti prenumeratos nustatymus',
    logout: 'Atsijungti',
    logoutFromAccount: 'Atsijungti nuo paskyros',
    
    // Toast Messages
    toast: {
      error: 'Klaida',
      success: 'Sėkmingai išsaugota',
      loadError: 'Nepavyko užkrauti užsakymų',
      emailUpdateError: 'Nepavyko atnaujinti el. pašto adreso',
      profileUpdateError: 'Nepavyko išsaugoti profilio',
      profileUpdated: 'Profilio informacija atnaujinta',
      addressUpdateError: 'Nepavyko išsaugoti adreso',
      addressUpdated: 'Adresas sėkmingai atnaujintas',
      preferencesUpdateError: 'Nepavyko išsaugoti nustatymų',
      preferencesUpdated: 'Prenumeratos nustatymai atnaujinti',
      passwordMismatch: 'Slaptažodžiai nesutampa',
      passwordTooShort: 'Slaptažodis turi būti mažiausiai 6 simbolių',
      passwordUpdateError: 'Nepavyko pakeisti slaptažodžio',
      passwordUpdated: 'Slaptažodis sėkmingai atnaujintas',
      loggedOut: 'Atsijungėte',
      loggedOutDesc: 'Sėkmingai atsijungėte iš paskyros',
    },
  },
  
  
  // Authentication
  auth: {
    title: 'BeauBox',
    subtitle: 'Prisijunkite prie savo paskyros',
    loginTab: 'Prisijungti',
    signupTab: 'Registruotis',
    loginTitle: 'Prisijungimas',
    loginDescription: 'Įveskite savo duomenis prisijungimui',
    signupTitle: 'Registracija',
    signupDescription: 'Sukurkite naują paskyrą',
    email: 'El. paštas',
    emailPlaceholder: 'vardas@example.com',
    password: 'Slaptažodis',
    passwordPlaceholder: 'Įveskite slaptažodį',
    createPasswordPlaceholder: 'Sukurkite slaptažodį',
    confirmPassword: 'Pakartokite slaptažodį',
    confirmPasswordPlaceholder: 'Pakartokite slaptažodį',
    firstName: 'Vardas',
    firstNamePlaceholder: 'Vardas',
    lastName: 'Pavardė',
    lastNamePlaceholder: 'Pavardė',
    forgotPassword: 'Pamiršote slaptažodį?',
    loginButton: 'Prisijungti',
    signupButton: 'Registruotis',
    loggingIn: 'Prisijungiama...',
    signingUp: 'Registruojamasi...',
    googleLogin: 'Prisijungti su Google',
    facebookLogin: 'Prisijungti su Facebook',
    or: 'Arba',
    loginSuccess: 'Sėkmingai prisijungėte!',
    loginSuccessDesc: 'Sveiki sugrįžę į BeauBox',
    loginError: 'Prisijungimo klaida',
    signupSuccess: 'Sėkmingai užsiregistravote!',
    signupSuccessDesc: 'Sveiki atvykę į BeauBox',
    signupError: 'Registracijos klaida',
    passwordMismatch: 'Slaptažodžiai nesutampa',
    passwordMismatchDesc: 'Patikrinkite, ar abu slaptažodžiai vienodi',
    googleLoginSuccess: 'Sėkmingai prisijungėte su Google!',
    googleLoginError: 'Google prisijungimo klaida',
    facebookLoginSuccess: 'Sėkmingai prisijungėte su Facebook!',
    facebookLoginError: 'Facebook prisijungimo klaida',
  },

  // Bendri
  common: {
    loading: 'Kraunama...',
    error: 'Klaida',
    success: 'Sėkmė',
    cancel: 'Atšaukti',
    save: 'Išsaugoti',
    delete: 'Ištrinti',
    edit: 'Redaguoti',
    add: 'Pridėti',
    close: 'Uždaryti',
    back: 'Atgal',
    next: 'Kitas',
    previous: 'Ankstesnis',
    submit: 'Pateikti',
  },
  
  termsOfUse: {
    title: 'Naudojimo sąlygos',
    subtitle: 'BeauBox.lt internetinės parduotuvės naudojimo taisyklės',
    lastUpdated: 'Paskutinis atnaujinimas',
    effectiveDate: 'Įsigalioja',
    
    section1: {
      title: '1. Bendrosios nuostatos',
      intro: 'Šios naudojimo sąlygos (toliau - „Sąlygos") reglamentuoja internetinės parduotuvės beaubox.lt naudojimą.',
      agreement: 'Naudodamasis šia svetaine, jūs sutinkate su šiomis sąlygomis ir įsipareigojate jų laikytis. Jei nesutinkate su šiomis sąlygomis, negalite naudotis mūsų paslaugomis.',
      sellerData: 'Pardavėjo duomenys:',
      companyCode: 'Įmonės kodas',
      vatCode: 'PVM mokėtojo kodas',
      address: 'Adresas',
      email: 'El. paštas',
      phone: 'Telefonas',
    },
    
    section2: {
      title: '2. Teikiamos paslaugos',
      intro: 'BeauBox.lt svetainėje teikiamos šios paslaugos:',
      service1: 'Grožio ir kosmetikos prekių pardavimas internetu',
      service2: 'Konsultacijos grožio klausimais',
      service3: 'Prekių pristatymas nurodytu adresu',
      service4: 'Nuotolinių prekybos paslaugų teikimas',
      service5: 'Klientų aptarnavimas',
      legal: 'Paslaugos teikiamos vadovaujantis Lietuvos Respublikos teisės aktais, ypač Civilinio kodekso, Vartotojų teisių apsaugos įstatymo ir Elektroninės komercijos įstatymo nuostatomis.',
    },
    
    section3: {
      title: '3. Registracija ir paskyra',
      registrationRequirements: '3.1 Registracijos reikalavimai',
      requirement1: 'Registruotis gali asmenys nuo 16 metų (nepilnamečiams reikia tėvų/globėjų sutikimo)',
      requirement2: 'Privaloma pateikti tikrus ir tikslus duomenis',
      requirement3: 'El. pašto adresas turi būti galiojantis ir prieinamas',
      requirement4: 'Slaptažodis turi būti saugus (ne mažiau 8 simbolių)',
      accountUsage: '3.2 Paskyros naudojimas',
      usage1: 'Atsakote už savo paskyros saugumą',
      usage2: 'Neleiskite tretiesiems asmenims naudotis jūsų paskyra',
      usage3: 'Nedelsdami praneškite apie nesankcionuotą prieigą',
      usage4: 'Galite ištrinti paskyrą bet kuriuo metu',
    },
    
    section4: {
      title: '4. Užsakymai ir mokėjimai',
      orderProcessing: '4.1 Užsakymų tvarkymas',
      processing1: 'Užsakymas laikomas patvirtintu po apmokėjimo gavimo',
      processing2: 'Rezervuojame teisę atšaukti užsakymą, jei prekės neturime sandėlyje',
      processing3: 'Apie užsakymo būklės pokyčius informuojame el. paštu',
      processing4: 'Užsakymo duomenys saugomi 10 metų apskaitos tikslais',
      paymentMethods: '4.2 Mokėjimo būdai',
      methodsIntro: 'Priimami mokėjimo būdai:',
      method1: 'Banko pavedimu',
      method2: 'Banko kortelėmis (Visa, Mastercard)',
      method3: 'Elektroninėmis mokėjimo sistemomis (Stripe)',
      method4: 'Atsiskaitymas gavus prekes (tik Lietuvoje)',
      pricesAndTaxes: '4.3 Kainos ir mokesčiai',
      price1: 'Visos kainos nurodytos su PVM',
      price2: 'Pristatymo kaina skaičiuojama atskirai',
      price3: 'Rezervuojame teisę keisti kainas be išankstinio perspėjimo',
      price4: 'Taikoma kaina užsakymo patvirtinimo metu',
    },
    
    section5: {
      title: '5. Pristatymas',
      deliveryTermsTitle: 'Pristatymo terminai:',
      term1: 'Lietuvoje: 1-3 darbo dienos',
      term2: 'ES šalyse: 3-7 darbo dienos',
      term3: 'Kitos šalys: pagal atskirą susitarimą',
      deliveryMethodsTitle: 'Pristatymo būdai:',
      method1: 'Kurjerių tarnyba į namus/biurą',
      method2: 'Paštomatai (Omniva)',
      method3: 'Pašto skyriai',
      method4: 'Atsiėmimas iš sandėlio (pagal susitarimą)',
      riskTransfer: 'Pristatymo rizika pereina pirkėjui prekę perdavus kurjerių tarnybai arba kitam pristatymo būdu.',
    },
    
    section6: {
      title: '6. Grąžinimas ir garantijos',
      distanceSalesTitle: '6.1 Nuotolinio pardavimo sutarties nutraukimas',
      distanceSalesIntro: 'Vadovaujantis Vartotojų teisių apsaugos įstatymu, turite teisę:',
      right1: 'Nutraukti sutartį per 14 kalendorinių dienų nuo prekės gavimo',
      right2: 'Grąžinti prekę originalios būklės (nenaudotą, nepažeistą)',
      right3: 'Išimtys: kosmetikos prekės, kurios buvo atidaromos ar naudojamos',
      right4: 'Grąžinimo išlaidas apmoka pirkėjas',
      qualityWarrantyTitle: '6.2 Prekių kokybės garantija',
      warranty1: 'Teikiame 2 metų kokybės garantiją',
      warranty2: 'Garantija galioja nuo prekės perdavimo dienos',
      warranty3: 'Garantija netaikoma netinkamo naudojimo atveju',
      warranty4: 'Defektų atveju prekę taisome, keičiame ar grąžiname pinigus',
    },
    
    section7: {
      title: '7. Intelektualaus turto teisės',
      intro: 'Visos svetainės turinys (tekstai, nuotraukos, logotipai, dizainas) priklauso UAB „Gražuolė" ar tretiesiems asmenims ir yra saugomas intelektualaus turto teisių.',
      prohibitedTitle: 'Draudžiama:',
      prohibited1: 'Kopijuoti svetainės turinį komerciniais tikslais',
      prohibited2: 'Naudoti mūsų prekės ženklus be sutikimo',
      prohibited3: 'Modifikuoti arba platinti svetainės kodą',
      prohibited4: 'Kurti svetainės kopijas ar atvirksčius inžinerinius sprendimus',
    },
    
    section8: {
      title: '8. Draudžiama veikla',
      intro: 'Naudodamiesi mūsų paslaugomis, įsipareigojate:',
      doNotBreakLaws: 'Nelaužyti įstatymų ir:',
      prohibition1: 'Nepažeisti kitų asmenų teisių',
      prohibition2: 'Nesiųsti šlamšto ar kenkėjiškų pranešimų',
      prohibition3: 'Nemėginti pažeisti svetainės saugumo',
      prohibition4: 'Nenaudoti automatizuotų sistemų duomenims rinkti',
      prohibition5: 'Neplatinti melagingos informacijos',
      prohibition6: 'Nefiksuoti atsiliepimų apie nepirktą produkciją',
    },
    
    section9: {
      title: '9. Atsakomybė',
      ourLiabilityTitle: '9.1 Mūsų atsakomybė',
      our1: 'Atsakome už prekių kokybę pagal galiojančius įstatymus',
      our2: 'Neatsakome už svetainės veiklos sutrikimus dėl techninių priežasčių',
      our3: 'Neatsakome už nuostolius, atsiradusius dėl netinkamo prekių naudojimo',
      our4: 'Maksimali atsakomybė neviršija užsakymo vertės',
      yourLiabilityTitle: '9.2 Jūsų atsakomybė',
      your1: 'Atsakote už pateiktų duomenų tikslumą',
      your2: 'Atsakote už paskyros saugumą',
      your3: 'Privalote laikytis šių naudojimo sąlygų',
      your4: 'Atsakote už žalą, padarytą pažeidus sąlygas',
    },
    
    section10: {
      title: '10. Ginčų sprendimas',
      consumerDisputesTitle: 'Vartotojų ginčai',
      consumerDisputesIntro: 'Vartotojų ginčai sprendžiami:',
      resolution1: 'Derybų keliu su BeauBox.lt atstovais',
      resolution2: 'Valstybinėje vartotojų teisių apsaugos tarnyboje',
      resolution3: 'Vartotojų ginčų komisijose',
      resolution4: 'Lietuvos Respublikos teismuose',
      consumerProtectionTitle: 'Vartotojų teisių apsaugos tarnyba:',
      consumerProtectionAddress: 'Vilniaus g. 25, 01402 Vilnius',
      consumerProtectionPhone: 'Tel. 8 5 262 6751',
      consumerProtectionEmail: 'El. paštas: info@vtat.lt',
      businessDisputesTitle: 'Verslo klientų ginčai',
      businessDisputes: 'Ginčai su verslo klientais sprendžiami Lietuvos Respublikos teismuose pagal Lietuvos Respublikos materialinę ir procesinę teisę.',
    },
    
    section11: {
      title: '11. Sąlygų keitimas ir kontaktai',
      termsChangesTitle: 'Sąlygų keitimas',
      termsChanges: 'Rezervuojame teisę keisti šias sąlygas. Apie esminius pakeitimus informuosime registruotus naudotojus el. paštu ne vėliau kaip 30 dienų iki pakeitimų įsigaliojimo.',
      contactTitle: 'Kontaktai',
      emailLabel: 'El. paštas:',
      phoneLabel: 'Telefonas:',
      workingHoursLabel: 'Darbo laikas:',
      workingHours: 'I-V 9:00-18:00',
      addressLabel: 'Adresas:',
    },
    
    footer: {
      relatedLinks: 'Susijusios nuorodos:',
      privacyPolicy: 'Privatumo politika',
      cookiePolicy: 'Slapukų politika',
      delivery: 'Pristatymas',
      returns: 'Grąžinimas',
    },
  },

  // Privacy Policy page
  privacyPolicy: {
    hero: {
      title: "Privatumo politika",
      subtitle: "BeauBox.lt privatumo politika pagal Bendrąjį duomenų apsaugos reglamentą (BDAR)",
      lastUpdate: "Paskutinis atnaujinimas:",
      effectiveDate: "Įsigalioja:",
      updateDate: "2024 m. sausis",
      effectiveValue: "2024 m. sausio 15 d."
    },
    dataController: {
      title: "Duomenų valdytojas",
      companyInfo: "Įmonės duomenys:",
      companyName: "MB \"Beaubox\"",
      companyCode: "Įmonės kodas:",
      vatCode: "PVM mokėtojo kodas:",
      address: "Adresas:",
      email: "El. paštas:",
      phone: "Telefonas:",
      dpoInfo: "Duomenų apsaugos pareigūnas:",
      dpoEmail: "El. paštas: info@beaubox.lt",
      dpoPhone: "Telefonas:",
      dpoAddress: "Pašto adresas:"
    },
    dataProcessing: {
      title: "Kokius duomenis renkame ir kodėl",
      account: {
        title: "Paskyros duomenys",
        data: "Duomenys:",
        dataValue: "Vardas, pavardė, el. pašto adresas, slaptažodis (užšifruotas), telefono numeris",
        purpose: "Tikslas:",
        purposeValue: "Paskyros sukūrimas, prisijungimas, užsakymų valdymas, klientų aptarnavimas",
        legalBasis: "Teisinis pagrindas:",
        legalBasisValue: "Sutartis (BDAR 6 str. 1 d. b punktas)",
        retention: "Saugojimo laikas:",
        retentionValue: "Kol galioja paskyra + 3 savaitės po ištrynimo prašymo"
      },
      orders: {
        title: "Užsakymų duomenys",
        dataValue: "Pristatymo adresas, sąskaitos duomenys, užsakytų prekių informacija, mokėjimo duomenys",
        purposeValue: "Užsakymų vykdymas, pristatymas, apskaita, garantijų administravimas",
        legalBasisValue: "Sutartis (BDAR 6 str. 1 d. b punktas), teisės akto reikalavimas (buhalterinė apskaita)",
        retentionValue: "10 metų (buhalterinės apskaitos reikalavimai)"
      },
      marketing: {
        title: "Rinkodaros duomenys",
        dataValue: "El. pašto adresas, pirkimo istorija, naršymo duomenys, nuostatos",
        purposeValue: "Naujienlaiškiai, personalizuoti pasiūlymai, reklamos optimizavimas",
        legalBasisValue: "Sutikimas (BDAR 6 str. 1 d. a punktas)",
        retentionValue: "Iki sutikimo atšaukimo + 1 metai statistikos tikslais"
      }
    },
    rights: {
      title: "Jūsų teisės",
      information: {
        title: "Teisė į informaciją",
        description: "Turite teisę žinoti, kokie duomenys apie jus renkami, kaip jie naudojami ir su kuo dalijamasi."
      },
      access: {
        title: "Teisė į prieigą",
        description: "Galite prašyti gauti kopiją visų apie jus tvarkomų duomenų. Atsakome per 30 dienų."
      },
      rectification: {
        title: "Teisė į ištaisymą",
        description: "Galite prašyti ištaisyti neteisingus ar nepilnus asmens duomenis."
      },
      erasure: {
        title: "Teisė į ištrynimą",
        description: "Galite prašyti ištrinti savo duomenis, jei nėra teisinio pagrindo juos saugoti."
      },
      portability: {
        title: "Teisė į perkeliamumą",
        description: "Galite gauti savo duomenis struktūrizuotu formatu ir perkelti kitur."
      },
      withdrawal: {
        title: "Teisė į atšaukimą",
        description: "Galite bet kuriuo metu atšaukti sutikimą duomenų tvarkymui."
      }
    },
    dataSharing: {
      title: "Su kuo dalijamės duomenimis",
      providers: {
        title: "Paslaugų teikėjai",
        delivery: "Pristatymo tarnybos:",
        deliveryValue: "Omniva - pristatymo duomenys",
        payment: "Mokėjimo sistemos:",
        paymentValue: "Stripe, bankai - mokėjimo duomenys",
        it: "IT paslaugos:",
        itValue: "Supabase (duomenų bazė), Google (analitika), Facebook (reklama)"
      },
      thirdParty: {
        title: "Duomenų perdavimas į trečias šalis",
        intro: "Kai kurie mūsų paslaugų teikėjai gali būti įsikūrę už EEE ribų:",
        usa: "JAV: Google, Facebook - taikomi ES-JAV duomenų privatumo sistema",
        gdpr: "Visi perdavimai vykdomi pagal BDAR reikalavimus",
        secure: "Naudojame tik paslaugų teikėjus su tinkamais apsaugos mechanizmais"
      }
    },
    security: {
      title: "Duomenų saugumas",
      technical: {
        title: "Techninės priemonės:",
        ssl: "SSL šifravimas duomenų perdavimui",
        encryption: "Slaptažodžių šifravimas duomenų bazėje",
        updates: "Reguliarūs saugumo atnaujinimai",
        access: "Prieigos kontrolė ir audito žurnalai",
        backup: "Duomenų atsarginės kopijos"
      },
      organizational: {
        title: "Organizacinės priemonės:",
        training: "Darbuotojų mokymai duomenų apsaugos klausimais",
        accessManagement: "Prieigos teisių valdymas",
        audits: "Reguliarūs saugumo auditai",
        incidents: "Incidentų reagavimo procedūros",
        contracts: "Duomenų tvarkymo sutartys su teikėjais"
      }
    },
    minors: {
      title: "Nepilnamečių duomenys",
      description: "Mūsų paslaugos skirtos asmenims nuo 16 metų. Jei esate jaunesni nei 16 metų, prašome gauti tėvų arba globėjų sutikimą prieš registruojantis mūsų svetainėje ar pateikiant asmens duomenis.",
      removal: "Jei sužinome, kad surinkome nepilnamečio duomenis be tinkamo sutikimo, nedelsdami juos ištriname."
    },
    contact: {
      title: "Kaip susisiekti ir pateikti skundą",
      dataProtection: {
        title: "Duomenų apsaugos klausimai",
        email: "El. paštas:",
        phone: "Telefonas:",
        postal: "Paštas:",
        responseTime: "Atsakome į užklausas per 30 kalendorinių dienų"
      },
      complaints: {
        title: "Skundai priežiūros institucijai",
        authority: "Valstybinė duomenų apsaugos inspekcija",
        address: "Adresas: L. Stuokos-Gucevičiaus g. 11A, 01122 Vilnius",
        email: "El. paštas: ada@ada.lt",
        phone: "Telefonas: +370 5 279 1445",
        website: "Svetainė: www.ada.lt"
      }
    },
    updates: {
      title: "Politikos keitimai",
      description: "Šią privatumo politiką galime keisti, kad ji atitiktų naujus teisės aktus, technologijų pokyčius ar mūsų veiklos poreikius. Apie esminius pakeitimus informuosime:",
      notification1: "El. paštu registruotiems naudotojams (30 dienų iš anksto)",
      notification2: "Paskelbdami pranešimą svetainėje",
      notification3: "Atnaujindami \"Paskutinio atnaujinimo\" datą šiame dokumente",
      agreement: "Tęsdami naudotis mūsų paslaugomis po pakeitimų paskelbimo, sutinkate su naująja politikos versija."
    }
  },

  // Admin
  admin: {
    panel: 'Admin panelė',
    backToStore: 'Atgal į parduotuvę',
    dashboard: 'Dashboard',
    heroSection: 'Hero sekcija',
    products: 'Produktai',
    categories: 'Kategorijos',
    skinTypes: 'Odos tipas',
    purpose: 'Paskirtis',
    brands: 'Prekių ženklai',
    translations: 'Vertimai',
    suppliers: 'Tiekėjai',
    customerOrders: 'Klientų užsakymai',
    supplierOrders: 'Tiekėjų užsakymai',
    invoices: 'Sąskaitos faktūros',
    carts: 'Krepšeliai',
    loyaltyPoints: 'Lojalumo taškai',
    users: 'Vartotojai',
    subscribers: 'Prenumeratoriai',
    contactMessages: 'Kontaktų žinutės',
    marketingEmails: 'Reklaminiai laiškai',
    settings: 'Nustatymai',
    shippingSettings: {
      title: "Pristatymo nustatymai",
      save: "Išsaugoti",
      saving: "Išsaugoma...",
      loading: "Kraunama...",
      deliveryMethods: "Pristatymo būdai",
      standardDelivery: "Standartinis pristatymas",
      omnivaParcelMachines: "Omniva paštomatai",
      salonPickup: "Atsiėmimas salone",
      freeShipping: "Nemokamas pristatymas",
      freeShippingThreshold: "Minimali suma nemokamam pristatymui (€)",
      freeShippingThresholdPlaceholder: "25.35",
      freeShippingDescription: "Klientai gaus nemokamą pristatymą, jei užsakymo suma viršys šią sumą",
      standardShippingCost: "Standartinio pristatymo kaina (€)",
      standardShippingCostPlaceholder: "5.99",
      standardShippingDescription: "Ši suma bus pridėta prie užsakymo, jei nebus pasiekta nemokamo pristatymo riba",
      deliveryTime: "Pristatymo laikas",
      deliveryTimeTextLt: "Pristatymo laiko tekstas (LT)",
      deliveryTimeTextEn: "Delivery time text (EN)",
      deliveryTimeTextLtPlaceholder: "Pristatymas per 2-3 darbo dienas",
      deliveryTimeTextEnPlaceholder: "Delivery in 2-3 business days",
      deliveryTimeDescription: "Tekstas, kuris bus rodomas krepšelyje ir pristatymo informacijoje",
      preview: "Peržiūra",
      previewFreeShipping: "Nemokamas pristatymas:",
      previewOrdersFrom: "Užsakymams nuo",
      previewStandardShipping: "Standartinis pristatymas:",
      previewOrdersUpTo: "užsakymams iki",
      previewDeliveryTime: "Pristatymo laikas:",
      successTitle: "Sėkmė",
      successDescription: "Pristatymo nustatymai išsaugoti",
      errorTitle: "Klaida",
      errorLoadDescription: "Nepavyko įkelti pristatymo nustatymų",
      errorSaveDescription: "Nepavyko išsaugoti pristatymo nustatymų",
    },
    
    // Purpose (Paskirtis)
    paskirtis: {
      title: "Paskirčių valdymas",
      addPurpose: "Pridėti paskirtį",
      editPurpose: "Redaguoti paskirtį",
      purposes: "Paskirtys",
      searchPlaceholder: "Ieškoti paskirčių...",
      name: "Pavadinimas",
      nameRequired: "Pavadinimas yra privalomas",
      namePlaceholder: "Pvz.: Veido priežiūra",
      slug: "Slug",
      slugPlaceholder: "Jei paliksite tuščią, bus sugeneruotas automatiškai",
      slugDescription: "URL adresas. Jei paliksite tuščią, bus sugeneruotas iš pavadinimo.",
      description: "Aprašymas",
      descriptionPlaceholder: "Paskirties aprašymas...",
      actions: "Veiksmai",
      edit: "Redaguoti",
      delete: "Ištrinti",
      cancel: "Atšaukti",
      update: "Atnaujinti",
      add: "Pridėti",
      loading: "Kraunama...",
      deleteConfirmTitle: "Ar tikrai norite ištrinti paskirtį?",
      deleteConfirmDescription: "Šis veiksmas negrįžtamas. Paskirtis bus ištrinta visam laikui.",
      successTitle: "Sėkmė",
      successUpdate: "Paskirtis sėkmingai atnaujinta",
      successAdd: "Paskirtis sėkmingai pridėta",
      successDelete: "Paskirtis sėkmingai ištrinta",
      errorTitle: "Klaida",
      errorLoad: "Nepavyko užkrauti paskirčių",
      errorSave: "Nepavyko išsaugoti paskirties",
      errorDelete: "Nepavyko ištrinti paskirties",
    },
    salonLocations: 'Salonų lokacijos',
    omnivaSettings: 'Omniva nustatymai',
    stripeSettings: 'Stripe nustatymai',
    features: 'Funkcijos',
    services: 'Paslaugos',
    specialists: 'Specialistai',
    bookings: 'Rezervacijos',
    discountCodes: 'Nuolaidų kodai',
    statistics: 'Statistika',
    loading: 'Kraunama...',
    quickActions: 'Greiti veiksmai',
    addProduct: 'Pridėti produktą',
    viewOrders: 'Peržiūrėti užsakymus',
    manageUsers: 'Valdyti vartotojus',
    recentOrders: 'Paskutiniai užsakymai',
    orderNumber: 'Užsakymo numeris',
    amount: 'Suma',
    status: 'Statusas',
    date: 'Data',
    noOrders: 'Užsakymų nėra',
    admin: 'Admin',
    moderator: 'Moderator',
    statusPending: 'Laukiama',
    statusProcessing: 'Vykdomas',
    statusShipped: 'Išsiųstas',
    statusDelivered: 'Pristatytas',
    statusCancelled: 'Atšauktas',
    
    // Subscribers
    subscribersManagement: 'Prenumeratorių valdymas',
    exportEmails: 'Eksportuoti el. pašto adresus',
    totalSubscribers: 'Viso prenumeratorių',
    activeSubscribers: 'Aktyvūs prenumeratoriai',
    unsubscribed: 'Atsisakė prenumeratos',
    subscribersList: 'Prenumeratoriai',
    searchByEmail: 'Ieškoti pagal el. pašto adresą...',
    emailAddress: 'El. pašto adresas',
    subscriberStatus: 'Statusas',
    subscriptionDate: 'Prenumeratos data',
    unsubscribeDate: 'Atsisakymo data',
    subscriberType: 'Tipas',
    statusUnsubscribed: 'Atsisakė',
    statusActive: 'Aktyvus',
    registeredUser: 'Registruotas vartotojas',
    guest: 'Svečias',
    noSubscribersFound: 'Prenumeratorių nerasta',
    noSubscribers: 'Prenumeratorių nėra',
    errorLoadingSubscribers: 'Nepavyko įkelti prenumeratorių',
    exportSuccess: 'Eksportuota {count} prenumeratorių el. pašto adresų',
    productCodeBarcode: 'Produkto kodas / Barcode (neprivaloma)',
    usedForScanner: 'Naudojamas skaitytuvui',
    eanUpcCode: 'EAN, UPC arba kitas kodas',
    barcodeDescription: 'Įveskite produkto brūkšninį kodą (EAN, UPC), kad vartotojai galėtų jį rasti su barcode skaitytuvu',
    gtinCode: 'GTIN kodas (neprivaloma)',
    gtinUsedFor: 'ChatGPT Shopping',
    gtinPlaceholder: 'GTIN, EAN-13, UPC-A arba ISBN',
    gtinDescription: 'Gamintojo identifikacinis numeris naudojamas ChatGPT Shopping ir kitoms prekybos platformoms',
    subscriptionPlans: 'Prenumeratos planai',
    
    // Product Form
    productForm: {
      addNewProduct: "Pridėti naują produktą",
      editProduct: "Redaguoti produktą",
      name: "Pavadinimas",
      namePlaceholder: "Produkto pavadinimas",
      nameRequired: "Pavadinimas yra privalomas",
      slug: "SEO nuoroda (slug)",
      slugPlaceholder: "produkto-pavadinimas (paliekite tuščią automatiniam generavimui)",
      slugHint: "Jei paliekate tuščią, slug bus automatiškai sugeneruotas iš prekės pavadinimo ir prekės ženklo",
      brand: "Prekės ženklas",
      brandRequired: "Prekės ženklas yra privalomas",
      brandPlaceholder: "Pasirinkite prekės ženklą",
      categories: "Kategorijos (pasirinkite vieną ar kelias)",
      categoriesRequired: "Bent viena kategorija yra privaloma",
      price: "Kaina (€)",
      pricePlaceholder: "0.00",
      priceRequired: "Kaina yra privaloma",
      discount: "Nuolaida (%)",
      discountPlaceholder: "0",
      priceAfterDiscount: "Kaina po nuolaidos:",
      youSave: "Sutaupoma:",
      supplier: "Tiekėjas",
      supplierRequired: "Tiekėjas privalomas",
      supplierPlaceholder: "Pasirinkite tiekėją",
      supplierPrice: "Tiekėjo kaina (€)",
      supplierPageLink: "Nuoroda į tiekėjo puslapį (neprivaloma)",
      skinType: "Odos tipas",
      skinTypeRequired: "Odos tipas yra privalomas",
      skinTypePlaceholder: "Pasirinkite odos tipą",
      purpose: "Paskirtis",
      purposePlaceholder: "Nepasirinkta",
      stockQuantity: "Atsargų kiekis",
      stockQuantityPlaceholder: "0",
      stockQuantityRequired: "Atsargų kiekis yra privalomas",
      images: "Produkto nuotraukos",
      imagesRequired: "Bent viena nuotrauka yra privaloma",
      description: "Aprašymas",
      descriptionPlaceholder: "Produkto aprašymas...",
      descriptionEn: "Aprašymas (EN)",
      descriptionEnPlaceholder: "Product description in English...",
      ingredients: "Sudėtis",
      ingredientsPlaceholder: "Produkto sudėtis ir ingredientai...",
      ingredientsEn: "Sudėtis (EN)",
      ingredientsEnPlaceholder: "Product ingredients in English...",
      usage: "Naudojimas",
      usagePlaceholder: "Kaip naudoti produktą...",
      usageEn: "Naudojimas (EN)",
      usageEnPlaceholder: "How to use the product in English...",
      pdfFiles: "PDF Failai",
      isNew: "Naujas produktas",
      isNewDescription: "Pažymėti kaip naują produktą",
      isBestseller: "Bestseleris",
      isBestsellerDescription: "Pažymėti kaip bestselerį",
      recommendedByCosmetologists: "Kosmetologų rekomenduojama",
      recommendedByCosmetologistsDescription: "Pažymėti kaip kosmetologų rekomenduojamą produktą",
      showPriceToUnregistered: "Kaina matoma visiems",
      showPriceToUnregisteredDescription: "Kaina bus matoma ir neprisijungusiems vartotojams",
      requiresConsultation: "Reikalinga konsultacija",
      requiresConsultationDescription: "Produktą galima pirkti tik po konsultacijos",
      hidePriceWithoutConsultation: "Slėpti kainą be konsultacijos",
      hidePriceWithoutConsultationDescription: "Kaina bus matoma tik tada, kai bus patvirtinta konsultacija",
      needsAttention: "Reikia dėmesio",
      needsAttentionDescription: "Pažymėkite, jei produktui reikia administratorių dėmesio",
      forProfessionalUseOnly: "Tik profesionaliam naudojimui",
      forProfessionalUseOnlyDescription: "Pažymėkite, jei produktas skirtas tik profesionaliam naudojimui",
      isCreatedManually: "Sukurta rankiniu būdu",
      isCreatedManuallyDescription: "Nurodo, ar produktas buvo sukurtas rankiniu būdu, ar importuotas/nukopijuotas",
      isInactive: "Neaktyvus produktas",
      isInactiveDescription: "Neaktyvūs produktai yra paslėpti nuo pirkėjų (nerodomos paieškoje, sąrašuose, neįmanoma pasiekti puslapio)",
      cancel: "Atšaukti",
      create: "Sukurti produktą",
      update: "Atnaujinti produktą",
      loading: "Kraunama...",
      success: "Sėkmė",
      productCreated: "Produktas sėkmingai sukurtas",
      productUpdated: "Produktas sėkmingai atnaujintas",
      error: "Klaida",
      productCreateError: "Nepavyko sukurti produkto",
      productUpdateError: "Nepavyko atnaujinti produkto",
    },

    // Category List
    categoryList: {
      title: 'Kategorijų valdymas',
      addCategory: 'Pridėti kategoriją',
      categories: 'Kategorijos',
      search: 'Ieškoti kategorijų...',
      loading: 'Kraunama...',
      image: 'Nuotrauka',
      nameLt: 'Pavadinimas (LT)',
      nameEn: 'Pavadinimas (EN)',
      slug: 'Slug',
      descriptionLt: 'Aprašymas (LT)',
      descriptionEn: 'Aprašymas (EN)',
      status: 'Statusas',
      filters: 'Filtrai',
      topNav: 'Viršutinė nav.',
      order: 'Tvarka',
      actions: 'Veiksmai',
      active: 'Aktyvi',
      inactive: 'Neaktyvi',
      yes: 'Taip',
      no: 'Ne',
      noImage: 'Nėra',
      editCategory: 'Redaguoti kategoriją',
      deleteTitle: 'Ar tikrai norite ištrinti kategoriją?',
      deleteDescription: 'Šis veiksmas negrįžtamas. Kategorija bus ištrinta visam laikui.',
      deleteCancel: 'Atšaukti',
      deleteConfirm: 'Ištrinti',
      deleteSuccess: 'Kategorija sėkmingai ištrinta',
      deleteError: 'Nepavyko ištrinti kategorijos',
      loadError: 'Nepavyko užkrauti kategorijų',
    },

    // Category Form
    categoryForm: {
      titleEdit: 'Redaguoti kategoriją',
      titleAdd: 'Pridėti kategoriją',
      nameLt: 'Pavadinimas (LT)',
      nameLtPlaceholder: 'Kategorijos pavadinimas',
      nameLtRequired: 'Pavadinimas yra privalomas',
      nameEn: 'Pavadinimas (EN)',
      nameEnPlaceholder: 'Category name in English',
      slug: 'Slug',
      slugPlaceholder: 'kategorijos-slug',
      slugRequired: 'Slug yra privalomas',
      slugDescription: 'URL-tinkamas pavadinimas (naudojamas nuorodose)',
      sortOrder: 'Rūšiavimo tvarka',
      sortOrderDescription: 'Mažesni skaičiai rodomi pirmi',
      sortOrderMin: 'Tvarka negali būti neigiama',
      image: 'Kategorijos nuotrauka',
      descriptionLt: 'Aprašymas (LT)',
      descriptionLtPlaceholder: 'Kategorijos aprašymas...',
      descriptionEn: 'Aprašymas (EN)',
      descriptionEnPlaceholder: 'Category description in English...',
      isActive: 'Aktyvi kategorija',
      isActiveDescription: 'Ar kategorija yra matoma svetainėje',
      showInMenu: 'Rodyti filtruose',
      showInMenuDescription: 'Ar kategorija bus rodoma filtruose ir paieškoje',
      showInHeader: 'Rodyti viršutinėje navigacijoje',
      showInHeaderDescription: 'Ar kategorija bus rodoma viršutinės navigacijos meniu',
      cancel: 'Atšaukti',
      update: 'Atnaujinti kategoriją',
      create: 'Sukurti kategoriją',
      updateSuccess: 'Kategorija sėkmingai atnaujinta',
      createSuccess: 'Kategorija sėkmingai sukurta',
      updateError: 'Nepavyko atnaujinti kategorijos',
      createError: 'Nepavyko sukurti kategorijos',
    },

    // Skin Types
    skinTypesList: {
      title: 'Odos tipų valdymas',
      addSkinType: 'Pridėti odos tipą',
      skinTypes: 'Odos tipai',
      search: 'Ieškoti odos tipų...',
      loading: 'Kraunama...',
      name: 'Pavadinimas',
      slug: 'Slug',
      description: 'Aprašymas',
      actions: 'Veiksmai',
      editSkinType: 'Redaguoti odos tipą',
      addNewSkinType: 'Pridėti odos tipą',
      deleteTitle: 'Ar tikrai norite ištrinti odos tipą?',
      deleteDescription: 'Šis veiksmas negrįžtamas. Odos tipas bus ištrintas visam laikui.',
      deleteCancel: 'Atšaukti',
      deleteConfirm: 'Ištrinti',
      deleteSuccess: 'Odos tipas sėkmingai ištrintas',
      deleteError: 'Nepavyko ištrinti odos tipo',
      loadError: 'Nepavyko užkrauti odos tipų',
      nameRequired: 'Pavadinimas yra privalomas',
      nameLabel: 'Pavadinimas *',
      namePlaceholder: 'Pvz.: Sausa oda',
      slugLabel: 'Slug',
      slugPlaceholder: 'Jei paliksite tuščią, bus sugeneruotas automatiškai',
      slugDescription: 'URL adresas. Jei paliksite tuščią, bus sugeneruotas iš pavadinimo.',
      descriptionLabel: 'Aprašymas',
      descriptionPlaceholder: 'Odos tipo aprašymas...',
      cancel: 'Atšaukti',
      update: 'Atnaujinti',
      add: 'Pridėti',
      updateSuccess: 'Odos tipas sėkmingai atnaujintas',
      addSuccess: 'Odos tipas sėkmingai pridėtas',
      saveError: 'Nepavyko išsaugoti odos tipo',
    },
    
    // Products page
    productsManagement: 'Produktų valdymas',
    regenerateSlugs: 'Atnaujinti slug\'us',
    productsCount: 'Produktai',
    searchProducts: 'Ieškoti produktų...',
    needsAttention: 'Reikia dėmesio',
    forProfessionals: 'Tik profesionalams:',
    inactive: 'Neaktyvus:',
    manuallyCreated: 'Rankiniu būdu:',
    all: 'Visi',
    yes: 'Taip',
    no: 'Ne',
    image: 'Img',
    name: 'Pavadinimas',
    brand: 'Prekės ženklas',
    category: 'Kategorija',
    price: 'Kaina',
    discount: 'Nuolaida',
    stock: 'Atsargos',
    tags: 'Žymės',
    actions: 'Veiksmai',
    viewMore: 'Visi odos tipai',
    editProduct: 'Redaguoti produktą',
    deleteProduct: 'Ištrinti produktą',
    deleteConfirmTitle: 'Ar tikrai norite ištrinti šį produktą?',
    deleteConfirmDescription: 'Šis veiksmas yra negrįžtamas.',
    delete: 'Ištrinti',
    cancel: 'Atšaukti',
    errorTitle: 'Klaida',
    errorLoadProducts: 'Nepavyko įkelti produktų',
    errorDeleteProduct: 'Nepavyko ištrinti produkto',
    successTitle: 'Sėkmė',
    successDeleteProduct: 'Produktas sėkmingai ištrintas',
    infoTitle: 'Informacija',
    noProductsFound: 'Nerasta jokių produktų',
    slugsRegeneratedSuccess: 'Sėkmingai atnaujinta {count} produktų slug\'ų. Klaidos: {errors}',
    errorRegenerateSlugs: 'Nepavyko atnaujinti slug\'ų',
  },

  // Subscription
  subscription: {
    title: 'Prenumerata',
    yourSubscription: 'Jūsų prenumerata',
    subscriptionPlans: 'Prenumeratos planai',
    subscribe: 'Prenumeruoti',
    alreadySubscribed: 'Jau prenumeruojate',
    active: 'Aktyvi',
    price: 'Kaina',
    renews: 'Atsinaujina',
    cancelSubscription: 'Atšaukti prenumeratą',
    resumeSubscription: 'Tęsti prenumeratą',
    cancelConfirmTitle: 'Atšaukti prenumeratą?',
    cancelConfirmDescription: 'Prenumerata bus atšaukta periodo pabaigoje. Turėsite prieigą iki tada.',
    confirm: 'Patvirtinti',
    cancel: 'Atšaukti',
    willCancelAtPeriodEnd: 'Prenumerata bus atšaukta periodo pabaigoje',
    noSubscription: 'Jūs šiuo metu neturite aktyvios prenumeratos.',
    subscribeAndSave: 'Prenumeruokite ir gaukite 10% nuolaidą visiems produktams',
    discountApplied: 'Jūs gaunate {discount}% nuolaidą visiems produktams!',
    month: 'mėn.',
    year: 'metai',
    noPlansAvailable: 'Prenumeratos planų nėra',
    perMonth: '/ mėn.',
    perYear: '/ metai',
    productSubscriptions: 'Produktų prenumeratos',
    productSubscriptionsDesc: 'Valdykite savo aktyvias produktų prenumeratas',
  },

  // Omniva Settings
  omnivaSettings: {
    title: 'Omniva nustatymai',
    save: 'Išsaugoti',
    saving: 'Išsaugoma...',
    apiConfiguration: 'API konfigūracija',
    apiUrl: 'API URL',
    apiUsername: 'API vartotojo vardas',
    apiPassword: 'API slaptažodis',
    contractNumber: 'Sutarties numeris',
    testMode: 'Testavimo režimas',
    senderInformation: 'Siuntėjo informacija',
    senderName: 'Siuntėjo pavadinimas',
    address: 'Adresas',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    country: 'Šalis',
    phoneNumber: 'Telefono numeris',
    emailAddress: 'El. pašto adresas',
    serviceConfiguration: 'Paslaugų konfigūracija',
    defaultServiceCode: 'Numatytasis paslaugos kodas',
    labelFormat: 'Etikečių formatas',
    deliveryMethods: 'Pristatymo būdai',
    parcelMachineService: 'Paštomatų paslaugos',
    courierService: 'Kurjerių paslaugos',
    automation: 'Automatizacija',
    autoCreateShipments: 'Automatiškai kurti siuntas',
    autoCreateShipmentsDesc: 'Automatiškai sukurti siuntas kai užsakymas patvirtinamas',
    parcelMachinesManagement: 'Paštomatų duomenų tvarkymas',
    parcelMachinesCache: 'Paštomatų sąrašo talpykla',
    parcelMachinesCacheDesc: 'Duomenys automatiškai atnaujinami kas 24 valandas iš https://www.omniva.lt/locations.json',
    refreshNow: 'Atnaujinti dabar',
    refreshing: 'Atnaujinama...',
    dataSource: 'Duomenų šaltinis:',
    omnivaPublicApi: 'Omniva viešas API',
    cacheValidity: 'Talpyklos galiojimas:',
    hours24: '24 valandos',
    howToGetCredentials: 'Kaip gauti Omniva kredencialus',
    step1: '<strong>1. Registracija:</strong> Užpildykite verslo pasiūlymo formą Omniva svetainėje',
    step2: '<strong>2. Sutartis:</strong> Pasirašykite verslo kliento sutartį su Omniva',
    step3: '<strong>3. API prieiga:</strong> Susisiekite su savo verslo kliento vadybininku dėl API prieigos',
    step4: '<strong>4. Testavimas:</strong> Pradėkite su testavimo aplinka prieš perjungiant į gamybos režimą',
    contactInfo: '<strong>Kontaktai:</strong> info@omniva.lt arba +370 700 72 727',
    productionEnv: 'Gamybos aplinka: https://edixml.post.ee',
    testingEnv: 'Testavimo aplinka: https://test-edixml.post.ee',
    yourApiUsername: 'Jūsų API vartotojo vardas',
    yourApiPassword: 'Jūsų API slaptažodis',
    yourContractNumber: 'Jūsų Omniva sutarties numeris',
    yourCompanyName: 'Jūsų įmonės pavadinimas',
    streetNumber: 'Gatvė, namo numeris',
    cityPlaceholder: 'Kaunas',
    postalCodePlaceholder: '47222',
    countryPlaceholder: 'LT',
    phonePlaceholder: '+37061964967',
    emailPlaceholder: 'info@beaubox.lt',
    serviceCodePlaceholder: 'PA',
    serviceCodeDesc: 'PA - Paštomatai, CD - Kurjeriai',
    labelFormatPlaceholder: 'PDF',
    savedSuccessTitle: 'Išsaugota!',
    savedSuccessDesc: 'Omniva nustatymai sėkmingai atnaujinti',
    errorTitle: 'Klaida',
    errorLoadSettings: 'Nepavyko įkelti Omniva nustatymų',
    errorSaveSettings: 'Nepavyko išsaugoti Omniva nustatymų',
    refreshSuccessTitle: 'Sėkmingai atnaujinta!',
    refreshSuccessDesc: 'Paštomatų sąrašas atnaujintas. Rasta {count} paštomatų.',
    errorRefreshCache: 'Nepavyko atnaujinti paštomatų sąrašo',
  },
  
  adminSuppliers: {
    title: 'Tiekėjai',
    addButton: 'Pridėti tiekėją',
    searchPlaceholder: 'Ieškoti tiekėjų...',
    loading: 'Kraunama...',
    table: {
      name: 'Pavadinimas',
      contactPerson: 'Kontaktinis asmuo',
      email: 'El. paštas',
      phone: 'Telefonas',
      status: 'Būsena',
      actions: 'Veiksmai'
    },
    status: {
      active: 'Aktyvus',
      inactive: 'Neaktyvus'
    },
    form: {
      editTitle: 'Redaguoti tiekėją',
      addTitle: 'Pridėti tiekėją',
      name: 'Pavadinimas',
      nameRequired: 'Pavadinimas yra privalomas',
      namePlaceholder: 'Tiekėjo pavadinimas',
      contactPerson: 'Kontaktinis asmuo',
      contactPersonPlaceholder: 'Vardas Pavardė',
      email: 'El. paštas',
      emailInvalid: 'Neteisingas el. pašto formatas',
      emailPlaceholder: 'info@tiekejas.lt',
      phone: 'Telefonas',
      phonePlaceholder: '+370 600 00000',
      website: 'Svetainė',
      websiteInvalid: 'Neteisingas URL formatas',
      websitePlaceholder: 'https://tiekejas.lt',
      address: 'Adresas',
      addressPlaceholder: 'Gatvė 1, Miestas',
      notes: 'Pastabos',
      notesPlaceholder: 'Papildoma informacija apie tiekėją...',
      isActive: 'Aktyvus',
      isActiveDescription: 'Ar šis tiekėjas yra aktyvus?',
      cancel: 'Atšaukti',
      create: 'Sukurti',
      update: 'Atnaujinti'
    },
    toast: {
      updateSuccess: 'Sėkmė',
      updateSuccessDesc: 'Tiekėjas sėkmingai atnaujintas',
      createSuccess: 'Sėkmė',
      createSuccessDesc: 'Tiekėjas sėkmingai sukurtas',
      deleteSuccess: 'Sėkmė',
      deleteSuccessDesc: 'Tiekėjas sėkmingai ištrintas',
      error: 'Klaida',
      loadError: 'Nepavyko įkelti tiekėjų',
      saveError: 'Nepavyko išsaugoti tiekėjo',
      deleteError: 'Nepavyko ištrinti tiekėjo'
    },
    deleteDialog: {
      title: 'Ar tikrai norite ištrinti šį tiekėją?',
      description: 'Šis veiksmas negalės būti atšauktas.',
      cancel: 'Atšaukti',
      delete: 'Ištrinti'
    },
    notFound: 'Tiekėjų nerasta'
  },

  // Admin Invoices
  adminInvoices: {
    title: 'Sąskaitos faktūros',
    loading: 'Kraunama...',
    search: 'Ieškoti pagal numerį, vardą ar el. paštą...',
    filterByStatus: 'Filtruoti pagal statusą',
    allStatuses: 'Visi statusai',
    noInvoices: 'Nerasta sąskaitų faktūrų',
    table: {
      number: 'Numeris',
      customer: 'Klientas',
      date: 'Data',
      amount: 'Suma',
      status: 'Statusas',
      paid: 'Apmokėta',
      actions: 'Veiksmai',
      yes: 'Taip',
      no: 'Ne',
    },
    status: {
      draft: 'Juodraštis',
      issued: 'Išrašyta',
      sent: 'Išsiųsta',
      paid: 'Apmokėta',
      unpaid: 'Neapmokėta',
      overdue: 'Pradelstas',
      cancelled: 'Atšaukta',
    },
    dialog: {
      title: 'Sąskaita faktūra',
      vatInvoice: 'PVM SĄSKAITA FAKTŪRA',
      invoice: 'SĄSKAITA FAKTŪRA',
      viewTooltip: 'Peržiūrėti sąskaitą',
      created: 'Sukurta',
      edit: 'Redaguoti',
      description: 'Peržiūrėkite ir redaguokite sąskaitos faktūros informaciją',
      customerInfo: 'Kliento informacija',
      customerShort: 'Klientas',
      invoiceInfo: 'Sąskaitos informacija',
      paymentInfo: 'Mokėjimo informacija',
      name: 'Vardas',
      email: 'El. paštas',
      phone: 'Telefonas',
      company: 'Įmonė',
      companyCode: 'Įmonės kodas',
      vatCode: 'PVM kodas',
      statusLabel: 'Statusas',
      paidLabel: 'Apmokėta',
      yesLabel: 'Taip',
      noLabel: 'Ne',
      issueDate: 'Išrašymo data',
      dueDate: 'Mokėjimo terminas',
      dueDateNotSet: 'Nenustatyta',
      paymentTerms: 'Mokėjimo sąlygos',
      paymentTermsPlaceholder: 'pvz., Net 30, Apmokėti iškart',
      paymentTermsPlaceholderEdit: 'Pvz., 30 dienų',
      notes: 'Pastabos',
      notesPlaceholder: 'Papildoma informacija...',
      notesEmpty: 'Nėra',
      items: 'Sąskaitos prekės',
      itemsTable: {
        product: 'Prekė',
        quantity: 'Kiekis',
        unitPrice: 'Vnt. kaina',
        price: 'Kaina',
        total: 'Suma',
        amount: 'Iš viso',
      },
      subtotal: 'Suma be PVM',
      subtotalNoVat: 'Suma',
      subtotalLabel: 'Tarpinė suma:',
      discount: 'Nuolaida:',
      vat: 'PVM',
      vatLabel: 'PVM:',
      total: 'Iš viso',
      totalLabel: 'Viso:',
      cancel: 'Atšaukti',
      delete: 'Ištrinti',
      deleteConfirmTitle: 'Ištrinti sąskaitą faktūrą?',
      deleteConfirmDescription: 'Ar tikrai norite ištrinti šią sąskaitą faktūrą? Šis veiksmas negrįžtamas.',
      deleteConfirm: 'Ištrinti',
      deleting: 'Trinama...',
      save: 'Išsaugoti',
      saving: 'Išsaugoma...',
      close: 'Uždaryti',
      downloadPdf: 'Atsisiųsti PDF',
      sendEmail: 'Siųsti el. paštu',
      sending: 'Siunčiama...',
      pdf: {
        vatInvoice: 'PVM SĄSKAITA FAKTŪRA',
        invoice: 'SĄSKAITA FAKTŪRA',
        number: 'Numeris:',
        date: 'Data:',
        dueDate: 'Terminas:',
        notSet: 'Nenustatyta',
        seller: 'PARDAVĖJAS:',
        customer: 'KLIENTAS:',
        companyCode: 'Įmonės kodas:',
        vatCode: 'PVM kodas:',
        items: 'PREKĖS:',
        product: 'Prekė',
        quantity: 'Kiekis',
        price: 'Kaina',
        amount: 'Suma',
        subtotalNoVatLabel: 'Suma:',
        subtotalLabel: 'Suma be PVM:',
        vatLabel: 'PVM:',
        totalLabel: 'IŠ VISO:',
        notes: 'Pastabos:',
        paymentTerms: 'Mokėjimo sąlygos:',
      }
    },
    toast: {
      errorLoading: 'Nepavyko įkelti sąskaitų faktūrų',
      errorLoadingItems: 'Nepavyko įkelti sąskaitos prekių',
      successUpdated: 'Sąskaita faktūra atnaujinta',
      errorUpdating: 'Nepavyko atnaujinti sąskaitos faktūros',
      errorPdfNotFound: 'PDF failas nerastas',
      errorDownloading: 'Nepavyko atsisiųsti PDF',
      success: 'Sėkmė!',
      updateSuccess: 'Sąskaita faktūra atnaujinta sėkmingai',
      updateError: 'Nepavyko atnaujinti sąskaitos faktūros',
      emailSent: 'El. paštas išsiųstas!',
      emailSentDescription: 'Sąskaita faktūra išsiųsta klientui el. paštu',
      emailError: 'Nepavyko išsiųsti el. pašto',
      error: 'Klaida',
      deleteSuccess: 'Sąskaita faktūra ištrinta sėkmingai',
      deleteError: 'Nepavyko ištrinti sąskaitos faktūros'
    },
  },

  // Admin Users
  adminUsers: {
    title: 'Vartotojų valdymas',
    users: 'Vartotojai',
    userId: 'Vartotojo ID',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    email: 'El. paštas',
    phone: 'Telefonas',
    role: 'Rolė',
    registrationDate: 'Registracijos data',
    actions: 'Veiksmai',
    edit: 'Redaguoti',
    search: 'Ieškoti vartotojų...',
    filterAllRoles: 'Visos rolės',
    filterByRole: 'Filtruoti pagal rolę',
    roleUser: 'Vartotojas',
    roleAdmin: 'Administratorius',
    roleModerator: 'Moderatorius',
    roleAdmins: 'Administratoriai',
    roleModerators: 'Moderatoriai',
    roleUsers: 'Vartotojai',
    editUser: 'Redaguoti vartotoją',
    editUserDescription: 'Keisti vartotojo profilį ir kontaktinius duomenis',
    personalInfo: 'Asmeninė informacija',
    companyInfo: 'Įmonės informacija',
    accountInfo: 'Paskyros informacija',
    shippingAddress: 'Pristatymo adresas',
    companyCode: 'Įmonės kodas',
    companyVat: 'PVM kodas',
    password: 'Naujas slaptažodis',
    passwordPlaceholder: 'Palikite tuščią, jei nenorite keisti',
    passwordTooShort: 'Slaptažodis turi būti bent 6 simboliai',
    street: 'Gatvė ir namo numeris',
    streetPlaceholder: 'Pvz. Romainiškių g. 47 - 1',
    city: 'Miestas',
    cityPlaceholder: 'Pvz. Vilnius',
    postalCode: 'Pašto kodas',
    postalCodePlaceholder: 'Pvz. 08000',
    country: 'Šalis',
    countryPlaceholder: 'Pvz. Lietuva',
    systemInfo: 'Sistemos informacija',
    userIdLabel: 'Vartotojo ID',
    firstNamePlaceholder: 'Įveskite vardą',
    lastNamePlaceholder: 'Įveskite pavardę',
    phonePlaceholder: 'Įveskite telefono numerį',
    companyCodePlaceholder: 'Įveskite įmonės kodą',
    companyVatPlaceholder: 'Įveskite PVM kodą',
    emailPlaceholder: 'Įveskite el. pašto adresą',
    saveChanges: 'Išsaugoti pakeitimus',
    cancel: 'Atšaukti',
    saving: 'Saugoma...',
    loading: 'Kraunama...',
    noUsers: 'Vartotojų nėra',
    noUsersFound: 'Vartotojų nerasta',
    emailNotAvailable: 'El. paštas nepasiekiamas',
    toast: {
      errorLoading: 'Klaida',
      errorLoadingDesc: 'Nepavyko įkelti vartotojų',
      roleSuccess: 'Sėkmė',
      roleSuccessDesc: 'Vartotojo rolė sėkmingai atnaujinta',
      roleError: 'Klaida',
      roleErrorDesc: 'Nepavyko atnaujinti vartotojo rolės',
      lastAdminError: 'Negalima pašalinti',
      lastAdminErrorDesc: 'Negalima pašalinti paskutinio administratoriaus. Turi likti bent vienas administratorius.',
      userSuccess: 'Sėkmė',
      userSuccessDesc: 'Vartotojo duomenys atnaujinti',
      userError: 'Klaida',
      userErrorDesc: 'Nepavyko atnaujinti vartotojo duomenų',
      emailWarning: 'Perspėjimas',
      emailWarningDesc: 'Profilis atnaujintas, bet el. pašto adreso nepavyko pakeisti',
      passwordWarning: 'Perspėjimas',
      passwordWarningDesc: 'Profilis atnaujintas, bet slaptažodžio nepavyko pakeisti',
    },
  },

  // Supplier Orders
  userCarts: {
    title: 'Vartotojų krepšeliai',
    refresh: 'Atnaujinti',
    searchPlaceholder: 'Ieškoti pagal el. paštą arba vardą...',
    showOnlyUnapproved: 'Rodyti tik nepatvirtintas konsultacijas',
    items: 'Prekės',
    consultations: 'Konsultacijos',
    approved: 'Patvirtinta',
    needsConsultation: 'Reikia konsultacijos',
    consultationManagement: 'Konsultacijų valdymas:',
    approve: 'Patvirtinti',
    revoke: 'Atšaukti',
    loading: 'Kraunama...',
    noCartsTitle: 'Nėra krepšelių',
    noCartsDescription: 'Šiuo metu nėra vartotojų su prekėmis krepšelyje',
    noSearchResults: 'Nerasta krepšelių pagal paieškos kriterijus',
    approveDialogTitle: 'Patvirtinti konsultaciją',
    user: 'Vartotojas',
    product: 'Produktas',
    notesLabel: 'Pastabos (neprivaloma)',
    notesPlaceholder: 'Įveskite pastabas apie konsultaciją...',
    cancel: 'Atšaukti',
    confirmApproval: 'Patvirtinti konsultaciją',
    alreadyApprovedTitle: 'Jau patvirtinta',
    alreadyApprovedDescription: 'Ši konsultacija jau buvo patvirtinta',
    approvalSuccessTitle: 'Konsultacija patvirtinta',
    approvalSuccessDescription: 'Vartotojas dabar gali pirkti šį produktą',
    approvalErrorTitle: 'Klaida',
    approvalErrorDescription: 'Nepavyko patvirtinti konsultacijos',
    revokeSuccessTitle: 'Patvirtinimas atšauktas',
    revokeSuccessDescription: 'Konsultacijos patvirtinimas buvo atšauktas',
    revokeErrorTitle: 'Klaida',
    revokeErrorDescription: 'Nepavyko atšaukti patvirtinimo',
    loadErrorTitle: 'Klaida',
    loadErrorDescription: 'Nepavyko užkrauti vartotojų krepšelių',
  },

  supplierOrders: {
    title: 'Tiekėjų užsakymai',
    description: 'Valdykite užsakymus tiekėjams',
    allOrders: 'Visi tiekėjų užsakymai',
    allOrdersDescription: 'Peržiūrėkite ir valdykite visus užsakymus tiekėjams',
    loading: 'Kraunama...',
    noOrders: 'Nerasta tiekėjų užsakymų',
    orderDate: 'Užsakymo data',
    supplier: 'Tiekėjas',
    status: 'Statusas',
    productCount: 'Produktų kiekis',
    amount: 'Suma',
    expectedDeliveryDate: 'Numatoma pristatymo data',
    actions: 'Veiksmai',
    statusPending: 'Laukiama',
    statusOrdered: 'Užsakyta',
    statusShipped: 'Išsiųsta',
    statusDelivered: 'Pristatyta',
    statusCancelled: 'Atšaukta',
    editOrderTitle: 'Redaguoti tiekėjo užsakymą',
    editOrderDescription: 'Atnaujinkite užsakymo informaciją',
    viewOrderTitle: 'Tiekėjo užsakymo detalės',
    viewOrderDescription: 'Peržiūrėkite užsakymo informaciją',
    amountLabel: 'Suma (€)',
    notes: 'Pastabos',
    cancel: 'Atšaukti',
    save: 'Išsaugoti',
    close: 'Uždaryti',
    products: 'Produktai',
    product: 'Produktas',
    brand: 'Prekės ženklas',
    quantity: 'Kiekis',
    price: 'Kaina',
    orderNumber: 'Užsakymo Nr.',
    orderUpdated: 'Tiekėjo užsakymas atnaujintas',
    orderUpdateError: 'Klaida atnaujinant užsakymą',
    orderDeleted: 'Tiekėjo užsakymas ištrintas',
    orderDeleteError: 'Klaida trinant užsakymą',
    confirmDelete: 'Ar tikrai norite ištrinti šį tiekėjo užsakymą?',
    exportedToCSV: 'Užsakymas eksportuotas į CSV',
    exportError: 'Klaida eksportuojant į CSV',
    noSupplierEmail: 'Tiekėjas neturi nurodyto el. pašto adreso',
    emailSent: 'Užsakymas išsiųstas el. paštu',
    emailError: 'Klaida siunčiant el. laišką',
  },

  // Invoice Manager Button
  invoiceManager: {
    checking: 'Tikrinama...',
    create: 'Sukurti sąskaitą',
    view: 'Peržiūrėti sąskaitą',
  },

  // Invoice Creation Dialog
  invoiceCreation: {
    title: 'Sąskaitos faktūros kūrimas',
    description: 'Sukurkite sąskaitą faktūrą užsakymui',
    orderSummary: 'Užsakymo suma',
    customer: 'Klientas',
    dueDate: 'Mokėjimo terminas',
    paymentTerms: 'Mokėjimo sąlygos',
    paymentTermsPlaceholder: 'pvz., Net 30, Apmokėti iškart',
    includeVat: 'Pridėti PVM',
    includeVatDescription: 'Ar įtraukti PVM į sąskaitos skaičiavimus? (Tarifas: {rate}%)',
    vatAmount: 'PVM suma',
    notes: 'Pastabos (neprivaloma)',
    notesPlaceholder: 'Papildoma informacija sąskaitai faktūrai...',
    cancelButton: 'Atšaukti',
    createButton: 'Sukurti sąskaitą',
    creating: 'Kuriama...',
    successTitle: 'Sąskaita sukurta!',
    successDescription: 'Ką norėtumėte daryti toliau?',
    downloadPdf: 'Atsisiųsti PDF',
    sendEmail: 'Siųsti el. paštu',
    downloading: 'Atsisiunčiama...',
    sending: 'Siunčiama...',
    close: 'Uždaryti',
    toast: {
      successCreated: 'Sąskaita faktūra {number} sukurta sėkmingai',
      errorCreating: 'Nepavyko sukurti sąskaitos faktūros',
      emailSent: 'El. paštas išsiųstas!',
      emailSentDescription: 'Sąskaita faktūra išsiųsta klientui el. paštu',
      errorSendingEmail: 'Nepavyko išsiųsti el. pašto',
    },
  },

  // Invoice Review Dialog
  invoiceReview: {
    title: 'Sąskaita faktūra',
    vatInvoice: 'PVM SĄSKAITA FAKTŪRA',
    regularInvoice: 'SĄSKAITA FAKTŪRA',
    created: 'Sukurta',
    customer: 'Klientas',
    paymentDetails: 'Mokėjimo informacija',
    issueDate: 'Išrašymo data',
    dueDate: 'Mokėjimo terminas',
    status: 'Statusas',
    paymentTerms: 'Mokėjimo sąlygos',
    paymentTermsPlaceholder: 'pvz., Net 30',
    notes: 'Pastabos',
    notesPlaceholder: 'Papildomos pastabos...',
    items: 'Prekės',
    itemsTable: {
      product: 'Prekė',
      description: 'Aprašymas',
      quantity: 'Kiekis',
      unitPrice: 'Vnt. kaina',
      total: 'Suma',
    },
    subtotal: 'Suma be PVM',
    regularSubtotal: 'Suma',
    vat: 'PVM',
    total: 'IŠ VISO',
    editButton: 'Redaguoti',
    cancelButton: 'Atšaukti',
    saveButton: 'Išsaugoti',
    downloadPdf: 'Atsisiųsti PDF',
    sendEmail: 'Siųsti el. paštu',
    saving: 'Išsaugoma...',
    sending: 'Siunčiama...',
    toast: {
      successUpdated: 'Sąskaita faktūra atnaujinta sėkmingai',
      errorUpdating: 'Nepavyko atnaujinti sąskaitos faktūros',
      emailSent: 'El. paštas išsiųstas!',
      emailSentDescription: 'Sąskaita faktūra išsiųsta klientui el. paštu',
      errorSendingEmail: 'Nepavyko išsiųsti el. pašto',
    },
  },

  // Admin Loyalty Points
  loyaltyPoints: {
    pageTitle: 'Lojalumo taškai',
    addRemovePoints: 'Pridėti/Atimti taškus',
    editPoints: 'Redaguoti lojalumo taškus',
    userLabel: 'Vartotojas',
    selectUser: 'Pasirinkite vartotoją',
    actionLabel: 'Veiksmas',
    addPoints: 'Pridėti taškus',
    removePoints: 'Atimti taškus',
    pointsAmount: 'Taškų kiekis',
    pointsAmountPlaceholder: '0.00',
    description: 'Aprašymas',
    descriptionPlaceholder: 'Įveskite priežastį...',
    cancel: 'Atšaukti',
    submitAdd: 'Pridėti taškus',
    submitRemove: 'Atimti taškus',
    usersAndPoints: 'Vartotojai ir taškai',
    searchUsers: 'Ieškoti vartotojų...',
    recentActivity: 'Paskutinė veikla',
    pointsAbbr: 'tšk.',
    userHistory: 'Lojalumo taškų istorija',
    totalPoints: 'Bendrai taškų:',
    orderLabel: 'Užsakymas:',
    loading: 'Kraunama...',
    errorLoadingUsers: 'Klaida',
    errorLoadingUsersDesc: 'Nepavyko įkelti vartotojų duomenų',
    errorLoadingEntries: 'Klaida',
    errorLoadingEntriesDesc: 'Nepavyko įkelti lojalumo taškų',
    errorLoadingHistory: 'Klaida',
    errorLoadingHistoryDesc: 'Nepavyko įkelti lojalumo taškų istorijos',
    errorLoadingUserHistory: 'Klaida',
    errorLoadingUserHistoryDesc: 'Nepavyko įkelti vartotojo istorijos',
    errorValidation: 'Klaida',
    errorValidationDesc: 'Užpildykite visus laukus',
    errorInvalidAmount: 'Klaida',
    errorInvalidAmountDesc: 'Įveskite teisingą taškų kiekį',
    successTitle: 'Sėkmė',
    successAdded: 'Sėkmingai pridėta',
    successRemoved: 'Sėkmingai atimta',
    successPoints: 'taškų',
    errorAdding: 'Klaida',
    errorAddingDesc: 'Nepavyko pridėti taškų',
  },

  oldAdminSettings: {
    title: 'Sistemos nustatymai - old',
    loading: 'Kraunama...',
    sections: {
      general: 'Bendrieji nustatymai',
      contact: 'Kontaktinė informacija',
      invoice: 'Sąskaitų faktūrų nustatymai',
      payment: 'Mokėjimo nustatymai',
      cache: 'Talpyklos valdymas',
      system: 'Sistemos informacija',
      migration: 'Paveikslėlių migracija',
      sitemap: 'Svetainės žemėlapio generavimas',
    },
    general: {
      adminEmail: 'Administratoriaus el. paštas',
      adminEmailPlaceholder: 'admin@example.com',
      adminEmailDescription: 'El. paštas sisteminiams pranešimams',
      contactEmail: 'Kontaktinis el. paštas',
      contactEmailPlaceholder: 'info@example.com',
      contactEmailDescription: 'Viešas kontaktinis el. paštas',
      phone: 'Telefonas',
      phonePlaceholder: '+370 600 00000',
      address: 'Adresas',
      addressPlaceholder: 'Įveskite įmonės adresą',
      siteTitle: 'Svetainės pavadinimas',
      siteTitlePlaceholder: 'Mano parduotuvė',
      companyName: 'Įmonės pavadinimas',
      companyNamePlaceholder: 'UAB Įmonė',
      logo: 'Logotipas',
      logoDescription: 'Įkelkite svetainės logotipą',
      save: 'Išsaugoti nustatymus',
      saving: 'Išsaugoma...',
      emailDomain: 'El. pašto domenas',
      emailDomainPlaceholder: 'example.com',
      emailDomainDescription: 'Domenas el. laiškų siuntimui iš sistemos',
      facebookUrl: 'Facebook URL',
      instagramUrl: 'Instagram URL',
      youtubeUrl: 'YouTube URL',
      companyPhone: 'Įmonės telefonas',
      companyEmail: 'Įmonės el. paštas',
      companyAddress: 'Įmonės adresas',
    },
    invoice: {
      vatCode: 'PVM kodas',
      vatCodePlaceholder: 'LT123456789',
      companyCode: 'Įmonės kodas',
      companyCodePlaceholder: '123456789',
      sellerName: 'Pardavėjo pavadinimas',
      sellerNamePlaceholder: 'UAB Įmonė',
      sellerAddress: 'Pardavėjo adresas',
      sellerAddressPlaceholder: 'Gatvė 1, Vilnius',
      sellerEmail: 'Pardavėjo el. paštas',
      sellerEmailPlaceholder: 'saskaitos@example.com',
      sellerPhone: 'Pardavėjo telefonas',
      sellerPhonePlaceholder: '+370 600 00000',
      bankName: 'Banko pavadinimas',
      bankNamePlaceholder: 'AB Swedbank',
      bankAccount: 'Banko sąskaita',
      bankAccountPlaceholder: 'LT123456789012345678',
      bankSwift: 'SWIFT kodas',
      bankSwiftPlaceholder: 'HABALT22',
      invoicePrefix: 'Sąskaitos prefiksas',
      invoicePrefixPlaceholder: 'SF-',
      invoiceDescription: 'Šie duomenys bus rodomi sąskaitose faktūrose',
      save: 'Išsaugoti sąskaitų nustatymus',
      saving: 'Išsaugoma...',
      vatRate: 'PVM tarifas (%)',
      vatRatePlaceholder: '21',
      invoiceEnabled: 'Įjungti sąskaitas faktūras',
      invoiceEnabledDescription: 'Leisti vartotojams generuoti sąskaitas faktūras',
    },
    payment: {
      payseraId: 'Paysera projekto ID',
      payseraIdPlaceholder: '123456',
      payseraPassword: 'Paysera slaptažodis',
      payseraPasswordPlaceholder: 'Įveskite Paysera slaptažodį',
      payseraCallbackUrl: 'Callback URL',
      payseraCallbackUrlPlaceholder: 'https://...',
      testMode: 'Testavimo režimas',
      testModeDescription: 'Įjungti Paysera testavimo režimą',
      save: 'Išsaugoti mokėjimo nustatymus',
      saving: 'Išsaugoma...',
      paymentMethod: 'Mokėjimo metodas',
      paymentMethodDescription: 'Pasirinkite Stripe mokėjimo metodą',
      redirect: 'Nukreipimas',
      inline: 'Įterptas',
    },
    cache: {
      title: 'Talpyklos valdymas',
      description: 'Išvalykite talpyklą, jei matote pasenusį turinį',
      clearButton: 'Išvalyti talpyklą',
      clearing: 'Valoma...',
      success: 'Talpykla sėkmingai išvalyta',
      error: 'Nepavyko išvalyti talpyklos',
      cacheControlMaxAge: 'Cache-Control Max-Age (sekundės)',
      cacheControlMaxAgePlaceholder: '31536000',
      cacheControlMaxAgeDescription: '1 metai = 31536000 sekundžių',
    },
    system: {
      title: 'Sistemos būsena',
      database: 'Duomenų bazė',
      connected: 'Prisijungta',
      disconnected: 'Atjungta',
      productsCount: 'Produktų skaičius',
      ordersCount: 'Užsakymų skaičius',
      usersCount: 'Vartotojų skaičius',
      viewLogs: 'Peržiūrėti žurnalus',
      logsTitle: 'Sistemos žurnalai',
      logsDescription: 'Paskutiniai sistemos įvykiai ir veikla',
      recentOrders: 'Naujausi užsakymai',
      recentProducts: 'Naujausi produktai',
      close: 'Uždaryti',
      automaticallyUpdated: 'Automatiškai atnaujinama',
      activeRoles: 'Aktyvios',
      working: 'Veikia',
      rlsEnabled: 'RLS įjungtas',
    },
    toast: {
      saveSuccess: 'Išsaugota!',
      saveSuccessDescription: 'Nustatymai sėkmingai išsaugoti',
      saveError: 'Klaida',
      saveErrorDescription: 'Nepavyko išsaugoti nustatymų',
      loadError: 'Nepavyko užkrauti nustatymų',
      invalidEmail: 'Neteisingas el. pašto formatas',
      emailEmpty: 'El. pašto adresas negali būti tuščias',
      emailDomainEmpty: 'El. pašto domenas negali būti tuščias',
      payseraFieldsRequired: 'Projekto ID ir slaptažodis yra privalomi',
      emailUpdated: 'Administratoriaus el. pašto adresas atnaujintas',
      emailDomainUpdated: 'El. pašto domenas atnaujintas',
      contactUpdated: 'Kontaktų nustatymai atnaujinti',
      logoUpdated: 'Logotipas atnaujintas',
      titleUpdated: 'Svetainės pavadinimas atnaujintas',
      vatUpdated: 'PVM tarifas atnaujintas',
      sellerUpdated: 'Pardavėjo informacija atnaujinta',
      invoiceUpdated: 'Sąskaitų funkcijos nustatymas atnaujintas',
      paymentMethodUpdated: 'Mokėjimo būdo nustatymas atnaujintas',
      payseraUpdated: 'Paysera nustatymai atnaujinti',
      cacheControlUpdated: 'Cache-Control nustatymai atnaujinti',
      logLoadError: 'Nepavyko įkelti sistemos žurnalų',
    },
  },
  contactMessages: {
    pageTitle: 'Kontaktų žinutės',
    cardTitle: 'Kontaktų žinutės',
    description: 'Paskutinės žinutės iš kontaktų formos',
    refresh: 'Atnaujinti',
    badge: {
      consultation: 'Konsultacija',
      message: 'Žinutė',
    },
    phone: 'Tel',
    reply: 'Atsakyti',
    loading: 'Kraunama...',
    noMessages: 'Žinučių nėra',
    toast: {
      loadError: 'Nepavyko įkelti kontaktų žinučių',
      errorTitle: 'Klaida',
    },
  },
  marketingEmails: {
    title: "Reklaminiai laiškai",
    description: "Siųskite profesionalius marketing el. laiškus savo klientams",
    templatesCount: "{{count}} šablonai",
    selectTemplate: "Pasirinkite šabloną",
    selectTemplateDescription: "Pasirinkite tinkamą šabloną jūsų kampanijai",
    configuration: "Konfigūracija",
    configurationDescription: "Nustatykite el. laiško turinį ir gavėjus",
    subject: "Tema",
    subjectPlaceholder: "El. laiško tema",
    templateVariables: "Kintamieji šablone",
    variablesHelp: "Užpildykite reikšmes žemiau esantiems kintamiesiems. Jie bus automatiškai įterpti į el. laišką.",
    recipients: "Gavėjai (atskirkite kableliais)",
    recipientsPlaceholder: "vardas@pastas.lt, kitas@pastas.com, dar_vienas@pastas.lt",
    recipientsHelp: "Įveskite el. pašto adresus atskiriant juos kableliais. Pavyzdžiui: info@example.com, john@example.com",
    preview: "Peržiūra",
    previewLabel: "El. laiško peržiūra",
    hide: "Slėpti",
    send: "Išsiųsti el. laiškus",
    sending: "Siunčiama...",
    enterValue: "Įveskite {{variable}} reikšmę",
    templates: {
      newProduct: {
        name: "Naujas produktas",
        description: "Būkite pirmieji išbandę mūsų naujausius..."
      },
      discount: {
        name: "Nuolaida / Išpardavimas",
        description: "Nepraleidkite šios specialios pasiūlymo..."
      },
      newsletter: {
        name: "Naujienlaiškis",
        description: "Sužinokite apie naujienas, patarimus ir..."
      },
      monthlyPromo: {
        name: "Mėnesio akcija su produktais",
        description: "Išskirtiniai produktai su nuolaida tik š..."
      }
    },
    toast: {
      errorTitle: "Klaida",
      noRecipients: "Įveskite bent vieną el. pašto adresą",
      invalidEmails: "Neteisingi el. pašto adresai: {{emails}}",
      sendError: "Nepavyko išsiųsti el. laiškų",
      successTitle: "Sėkmingai išsiųsta!",
      successDescription: "El. laiškai išsiųsti {{count}} gavėjams"
    }
  },

  adminSettings: {
    title: 'Sistemos nustatymai',
    logoTitle: {
      title: 'Logotipo ir pavadinimo nustatymai',
      siteTitle: 'Svetainės pavadinimas',
      siteTitlePlaceholder: 'BeauBox',
      savingTitle: 'Išsaugoma...',
      saveTitle: 'Išsaugoti pavadinimą',
      logoLabel: 'Įmonės logotipas (neprivaloma)',
      savingLogo: 'Išsaugoma...',
      saveLogo: 'Išsaugoti logotipą',
      logoHelpText: 'Logotipas bus rodomas šalia svetainės pavadinimo puslapio antraštėje'
    },
    contact: {
      title: 'Kontaktų informacija ir socialiniai tinklai',
      phone: 'Telefono numeris',
      phonePlaceholder: '+37061964967',
      email: 'El. pašto adresas',
      emailPlaceholder: 'info@beaubox.lt',
      address: 'Adresas',
      addressPlaceholder: 'Romainiškių g. 47 - 1, Kaunas, Lietuva, LT47222',
      socialNetworks: 'Socialiniai tinklai',
      facebookUrl: 'Facebook URL',
      facebookPlaceholder: 'https://facebook.com/...',
      instagramUrl: 'Instagram URL',
      instagramPlaceholder: 'https://instagram.com/...',
      youtubeUrl: 'YouTube URL',
      youtubePlaceholder: 'https://youtube.com/...',
      saving: 'Išsaugoma...',
      save: 'Išsaugoti kontaktų nustatymus'
    },
    email: {
      title: 'El. pašto nustatymai',
      adminEmail: 'Administratoriaus el. paštas',
      adminEmailPlaceholder: 'admin@beaubox.lt',
      adminEmailHelp: 'Kontaktų formos žinutės bus siunčiamos į šį el. paštą',
      emailDomain: 'El. pašto siuntimo domenas',
      emailDomainPlaceholder: 'beaubox.lt',
      emailDomainHelp: 'Domenas, iš kurio bus siunčiami sisteminiai el. laiškai (sąskaitos faktūros ir pan.)'
    },
    seller: {
      title: 'Pardavėjo informacija sąskaitoms faktūroms',
      companyName: 'Įmonės pavadinimas',
      companyNamePlaceholder: 'BeauBox UAB',
      companyCode: 'Įmonės kodas',
      companyCodePlaceholder: '123456789',
      vatCode: 'PVM mokėtojo kodas',
      vatCodePlaceholder: 'LT123456789',
      bankName: 'Bankas',
      bankNamePlaceholder: 'Swedbank AB',
      bankAccount: 'Banko sąskaita (IBAN)',
      bankAccountPlaceholder: 'LT123456789012345678',
      bankSwift: 'SWIFT/BIC kodas',
      bankSwiftPlaceholder: 'HABALT22',
      saving: 'Išsaugoma...',
      save: 'Išsaugoti pardavėjo informaciją',
      helpText: 'Ši informacija bus automatiškai įtraukta į visas kuriamas sąskaitas faktūras'
    },
    invoice: {
      title: 'Sąskaitų ir PVM nustatymai',
      functionality: 'Sąskaitų funkcionalumas',
      functionalityHelp: 'Įjunkite arba išjunkite sąskaitų skiltį vartotojų profilio puslapyje',
      saving: 'Išsaugoma...',
      save: 'Išsaugoti sąskaitų nustatymus',
      paymentMethod: 'Stripe mokėjimo būdas',
      paymentMethodHelp: 'Pasirinkite ar mokėjimas bus peradresuojamas į Stripe arba vykdomas puslapyje',
      redirect: 'Peradresavimas',
      inline: 'Puslapyje',
      savePaymentMethod: 'Išsaugoti mokėjimo nustatymus',
      vatRate: 'PVM tarifas (%)',
      vatRatePlaceholder: '21',
      vatRateHelp: 'Šis PVM tarifas bus naudojamas sąskaitų faktūrų kūrimui (standartinis 21%)'
    },
    paysera: {
      title: 'Paysera mokėjimo nustatymai',
      projectId: 'Projekto ID',
      projectIdPlaceholder: '12345',
      password: 'Slaptažodis',
      passwordPlaceholder: 'Paysera slaptažodis',
      callbackUrl: 'Callback URL',
      callbackUrlPlaceholder: 'https://hkownwweihaqtwnjbdzy.supabase.co/functions/v1/paysera-callback',
      testMode: 'Testavimo režimas',
      testModeHelp: 'Įjunkite testavimo režimą, kad mokėjimai būtų apdorojami Paysera testavimo aplinkoje',
      saving: 'Išsaugoma...',
      save: 'Išsaugoti Paysera nustatymus',
      helpText: 'Šie duomenys reikalingi Paysera mokėjimų apdorojimui. Projekto ID ir slaptažodį galite rasti savo Paysera administracijos panelėje. Testavimo režimas leidžia atlikti bandomuosius mokėjimus.'
    },
    cache: {
      title: 'Cache-Control nustatymai',
      maxAge: 'Cache-Control max-age (sekundės)',
      maxAgePlaceholder: '31536000',
      helpText: 'Nustatykite, kiek laiko (sekundėmis) naršyklė turėtų laikyti failus cache. Rekomenduojama: 31536000 (1 metai) statiniams failams kaip produktų nuotraukos. Tai sumažina duomenų naudojimą ir pagerina svetainės našumą.',
      timeUnits: {
        hour: '3600 = 1 valanda',
        day: '86400 = 1 diena',
        week: '604800 = 1 savaitė',
        month: '2592000 = 1 mėnuo',
        year: '31536000 = 1 metai (rekomenduojama)'
      },
      saving: 'Išsaugoma...',
      save: 'Išsaugoti Cache-Control'
    },
    system: {
      title: 'Sistemos būsena',
      productsCount: 'Produktų skaičius',
      usersCount: 'Vartotojų skaičius',
      database: 'Duomenų bazė',
      rlsEnabled: 'RLS įjungtas',
      automaticallyUpdated: 'Automatiškai atnaujinama',
      activeRoles: 'Aktyvūs vaidmenys',
      working: 'Veikia'
    },
    database: {
      title: 'Duomenų bazės valdymas',
      description: 'Duomenų bazės operacijos ir priežiūra atliekama automatiškai.',
      updateCache: 'Atnaujinti produktų cache',
      exportData: 'Eksportuoti duomenis',
      diagnostics: 'Sistemos diagnostika'
    },
    security: {
      title: 'Saugumo nustatymai',
      description: 'Row Level Security (RLS) politikos yra aktyvios visoms lentelėms.',
      rlsProducts: 'RLS produktams',
      rlsOrders: 'RLS užsakymams',
      rlsUsers: 'RLS vartotojams',
      active: 'Aktyvus'
    },
    actions: {
      title: 'Administratoriaus veiksmai',
      description: 'Greiti veiksmai sistemos administravimui.',
      viewLogs: 'Peržiūrėti sistemos žurnalus',
      loading: 'Kraunama...',
      updateConfig: 'Atnaujinti sistemos konfigūraciją',
      maintenanceMode: 'Perjungti priežiūros režimą'
    },
    systemInfo: {
      title: 'Sistemos informacija',
      version: 'Versija:',
      databaseLabel: 'Duomenų bazė:',
      databaseValue: 'Supabase PostgreSQL',
      authentication: 'Autentifikacija:',
      authenticationValue: 'Supabase Auth',
      lastUpdate: 'Paskutinis atnaujinimas:',
      environment: 'Aplinka:',
      environmentValue: 'Gamyba',
      region: 'Regionas:',
      regionValue: 'Europe'
    },
    logs: {
      title: 'Sistemos žurnalai',
      description: 'Paskutinė sistemos veikla ir įvykiai',
      noLogs: 'Žurnalų nėra',
      orderCreated: 'Užsakymas sukurtas:',
      productUpdated: 'Produktas atnaujintas:'
    },
    toast: {
      saveSuccess: 'Išsaugota',
      saveError: 'Klaida išsaugant',
      saveErrorDescription: 'Įvyko klaida išsaugant nustatymus',
      emailEmpty: 'El. pašto adresas negali būti tuščias',
      invalidEmail: 'Neteisingas el. pašto adresas',
      emailUpdated: 'Administratoriaus el. paštas atnaujintas',
      emailDomainEmpty: 'El. pašto domenas negali būti tuščias',
      emailDomainUpdated: 'El. pašto domenas atnaujintas',
      contactUpdated: 'Kontaktų nustatymai atnaujinti',
      logoUpdated: 'Logotipas atnaujintas',
      titleUpdated: 'Svetainės pavadinimas atnaujintas',
      vatUpdated: 'PVM tarifas atnaujintas',
      sellerUpdated: 'Pardavėjo informacija atnaujinta',
      invoiceUpdated: 'Sąskaitų nustatymai atnaujinti',
      paymentMethodUpdated: 'Mokėjimo būdas atnaujintas',
      payseraFieldsRequired: 'Projekto ID ir slaptažodis yra privalomi',
      payseraUpdated: 'Paysera nustatymai atnaujinti',
      cacheControlUpdated: 'Cache-Control nustatymai atnaujinti',
      logLoadError: 'Klaida kraunant sistemos žurnalus'
    }
  },

  // Admin Orders
  adminOrders: {
    pageTitle: 'Užsakymų valdymas',
    ordersCount: 'Užsakymai',
    searchPlaceholder: 'Ieškoti pagal numerį ar ID...',
    filterPlaceholder: 'Filtruoti pagal statusą',
    allStatuses: 'Visi statusai',
    createSupplierOrders: 'Sukurti tiekėjų užsakymus',
    loading: 'Kraunama...',
    noOrdersFound: 'Užsakymų nerasta',
    noOrders: 'Užsakymų nėra',
    incompleteData: 'Nepilni duomenys',
    // Table headers
    orderNumber: 'Užsakymo numeris',
    amount: 'Suma',
    status: 'Statusas',
    paymentStatus: 'Mokėjimo statusas',
    date: 'Data',
    actions: 'Veiksmai',
    // Statuses
    statuses: {
      pending: 'Laukiama',
      processing: 'Vykdomas',
      shipped: 'Išsiųstas',
      delivered: 'Pristatytas',
      cancelled: 'Atšauktas'
    },
    // Payment statuses
    paymentStatuses: {
      pending: 'Laukiama',
      paid: 'Apmokėtas',
      completed: 'Apmokėtas',
      succeeded: 'Apmokėtas',
      failed: 'Nepavyko'
    },
    // Delivery methods
    deliveryMethods: {
      salonPickup: 'Atsiėmimas salone',
      salonPickupDesc: 'Produktai bus paruošti atsiėmimui salone',
      parcelMachine: 'Omniva paštomate',
      parcelMachineDesc: 'Pristatymas į pasirinktą Omniva pašto terminalą',
      standardDelivery: 'Standartinis pristatymas',
      standardDeliveryDesc: 'Pristatymas kurjeriu į nurodytą adresą',
      expressDelivery: 'Greitasis pristatymas',
      expressDeliveryDesc: 'Pristatymas per 1-2 darbo dienas',
      defaultDeliveryDesc: 'Pristatymas į nurodytą adresą'
    },
    // Delete confirmation
    deleteConfirmTitle: 'Ar tikrai norite ištrinti užsakymą?',
    deleteConfirmDescription: 'Šis veiksmas negrįžtamas. Užsakymas ir visos jo prekės bus ištrinti visiems laikams.',
    deleteButton: 'Ištrinti',
    cancelButton: 'Atšaukti',
    // Order details dialog
    orderDetails: 'Užsakymo detalės',
    editButton: 'Redaguoti',
    saveButton: 'Išsaugoti',
    // Customer information
    customerInfo: 'Kliento informacija',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    phone: 'Telefonas',
    customerId: 'Kliento ID',
    companyInfo: 'Įmonės informacija',
    companyCode: 'Įmonės kodas',
    vatCode: 'PVM kodas',
    // Order information
    orderInfo: 'Užsakymo informacija',
    orderId: 'Užsakymo ID',
    paymentMethod: 'Mokėjimo metodas',
    selectPaymentMethod: 'Pasirinkite mokėjimo metodą',
    createdAt: 'Sukūrimo data',
    notes: 'Pastabos',
    // Payment methods
    paymentMethods: {
      cash: 'Grynaisiais',
      card: 'Banko kortele',
      bankTransfer: 'Banko pavedimas',
      other: 'Kitas'
    },
    // Shipping information
    shippingInfo: 'Siuntimo informacija',
    trackingNumber: 'Siuntimo numeris',
    trackingNumberPlaceholder: 'Įveskite siuntimo numerį',
    carrier: 'Vežėjas',
    selectCarrier: 'Pasirinkite vežėją',
    estimatedDelivery: 'Tikėtina pristatymo data',
    // Delivery information
    deliveryInfo: 'Pristatymo informacija',
    email: 'El. paštas',
    address: 'Adresas',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    country: 'Šalis',
    deliveryMethod: 'Pristatymo būdas',
    noDeliveryInfo: 'Pristatymo informacija nepateikta',
    omnivaLocation: 'Omniva vieta',
    salonAddress: 'Atsiėmimo adresas',
    salonName: 'Salono pavadinimas',
    // Order summary
    orderSummary: 'Užsakymo suvestinė',
    itemsValueBeforeDiscount: 'Prekių vertė (prieš nuolaidą):',
    loyaltyPointsUsed: 'Lojalumo taškai',
    itemsValueAfterDiscount: 'Prekių vertė (po nuolaidos):',
    delivery: 'Pristatymas:',
    freeDelivery: 'Nemokamas',
    total: 'Iš viso:',
    // Order items
    orderItems: 'Užsakymo prekės',
    addItem: 'Pridėti prekę',
    product: 'Prekė',
    brand: 'Prekės ženklas',
    quantity: 'Kiekis',
    unitPrice: 'Vnt. kaina',
    discount: 'Nuolaida',
    itemTotal: 'Suma',
    inSupplierOrder: 'Tiekėjo užsakyme',
    included: 'Įtraukta',
    notIncluded: 'Neįtraukta',
    itemArrived: 'Prekė atvyko',
    noItems: 'Prekių nėra',
    // Product search
    selectProduct: 'Pasirinkti prekę',
    selectProductDescription: 'Ieškokite ir pasirinkite prekę, kurią norite pridėti prie užsakymo',
    searchProduct: 'Ieškoti prekės...',
    noProductsFound: 'Prekių nerasta',
    productId: 'ID',
    // Supplier orders dialog
    supplierOrdersTitle: 'Tiekėjų užsakymai',
    supplierOrdersDescription: 'Sugeneruoti užsakymai tiekėjams pagal pasirinktus klientų užsakymus',
    dateLabel: 'Data:',
    createAndSendOrders: 'Sukurti ir siųsti užsakymus tiekėjams',
    noSupplierOrders: 'Nepavyko sukurti tiekėjų užsakymų',
    noItemsForSuppliers: 'Visos pasirinktos prekės jau įtrauktos į tiekėjų užsakymus arba neturi priskirtų tiekėjų.',
    missingInfoTitle: 'Trūkstama informacija',
    missingInfoDescription: 'Šios prekės negali būti įtrauktos į tiekėjų užsakymus:',
    missingSupplier: 'Nepriskirtas tiekėjas',
    missingUrl: 'Nėra tiekėjo nuorodos',
    orderRef: 'Užs.:',
    unknownSupplier: 'Nežinomas tiekėjas',
    toast: {
      error: 'Klaida',
      success: 'Sėkmė',
      loadOrdersError: 'Nepavyko įkelti užsakymų',
      loadProductsError: 'Nepavyko įkelti prekių',
      selectAtLeastOne: 'Pasirinkite bent vieną užsakymą',
      generateError: 'Nepavyko sugeneruoti tiekėjų užsakymų',
      loadItemsError: 'Nepavyko įkelti užsakymo prekių',
      statusUpdated: 'Užsakymo statusas atnaujintas',
      statusUpdateError: 'Nepavyko atnaujinti užsakymo statuso',
      orderDeleted: 'Užsakymas ištrintas',
      deleteError: 'Nepavyko ištrinti užsakymo',
      orderUpdated: 'Užsakymas atnaujintas',
      updateError: 'Nepavyko atnaujinti užsakymo',
      itemStatusError: 'Nepavyko atnaujinti prekės statuso',
      itemStatusUpdated: 'Atnaujinta',
      itemArrivedUpdated: 'Prekės atvykimo statusas atnaujintas',
      supplierOrdersCreated: 'Tiekėjų užsakymai sukurti',
      supplierOrdersError: 'Nepavyko sukurti tiekėjų užsakymų',
      userNotLoggedIn: 'Vartotojas neprisijungęs'
    }
  },

  // Brands
  brands: {
    title: 'Prekių ženklai',
    addBrand: 'Pridėti prekės ženklą',
    editBrand: 'Redaguoti prekės ženklą',
    searchPlaceholder: 'Ieškoti prekių ženklų...',
    loading: 'Kraunama...',
    noBrands: 'Nėra prekių ženklų',
    noBrandsFound: 'Prekių ženklų nerasta',
    table: {
      logo: 'Logo',
      name: 'Pavadinimas',
      description: 'Aprašymas',
      status: 'Būsena',
      sortOrder: 'Rūšiavimo tvarka',
      createdAt: 'Sukurta',
      actions: 'Veiksmai',
    },
    status: {
      active: 'Aktyvus',
      inactive: 'Neaktyvus',
    },
    deleteConfirm: {
      title: 'Ištrinti prekės ženklą?',
      description: 'Ar tikrai norite ištrinti prekės ženklą "{name}"? Šis veiksmas negrįžtamas.',
      cancel: 'Atšaukti',
      delete: 'Ištrinti',
    },
    toast: {
      loadError: 'Nepavyko užkrauti prekių ženklų',
      deleted: 'Prekės ženklas ištrintas',
      deletedDesc: 'Prekės ženklas sėkmingai ištrintas',
      deleteError: 'Nepavyko ištrinti prekės ženklo',
      activated: 'Prekės ženklas įjungtas',
      deactivated: 'Prekės ženklas išjungtas',
      statusChanged: 'Prekės ženklas "{name}" {status}',
      statusError: 'Nepavyko pakeisti prekės ženklo būsenos',
    },
    form: {
      name: 'Pavadinimas',
      nameRequired: 'Pavadinimas *',
      namePlaceholder: 'Prekės ženklo pavadinimas',
      slug: 'URL slug',
      slugPlaceholder: 'prekės-ženklo-slug',
      description: 'Aprašymas',
      descriptionPlaceholder: 'Trumpas prekės ženklo aprašymas',
      logo: 'Logo',
      uploadLogo: 'Įkelti logo',
      logoPreview: 'Logo peržiūra',
      websiteUrl: 'Svetainės adresas',
      websiteUrlPlaceholder: 'https://example.com',
      sortOrder: 'Rūšiavimo tvarka',
      isActive: 'Aktyvus',
      cancel: 'Atšaukti',
      save: 'Sukurti',
      update: 'Atnaujinti',
      saving: 'Išsaugoma...',
      nameRequiredError: 'Prekės ženklo pavadinimas yra privalomas',
      slugExistsError: 'Prekės ženklas su tokiu pavadinimu jau egzistuoja',
      created: 'Prekės ženklas sukurtas',
      createdDesc: 'Prekės ženklas "{name}" sėkmingai sukurtas',
      updated: 'Prekės ženklas atnaujintas',
      updatedDesc: 'Prekės ženklas "{name}" sėkmingai atnaujintas',
      createError: 'Nepavyko sukurti prekės ženklo',
      updateError: 'Nepavyko atnaujinti prekės ženklo',
    },
  },

  // Salon Locations
  salonLocations: {
    pageTitle: 'Salonų valdymas',
    addSalon: 'Pridėti saloną',
    noSalons: 'Nėra salonų',
    noSalonsDescription: 'Pridėkite pirmą saloną, kad klientai galėtų pasirinkti atsiėmimo vietą.',
    loading: 'Kraunama...',
    address: 'Adresas',
    phone: 'Telefonas',
    workingHours: 'Darbo laikas',
    active: 'Aktyvus',
    inactive: 'Neaktyvus',
    confirmDelete: 'Ar tikrai norite ištrinti šį saloną?',
    toast: {
      loadError: 'Nepavyko įkelti salonų sąrašo',
      deleteSuccess: 'Salonas ištrintas',
      deleteError: 'Nepavyko ištrinti salono',
      error: 'Klaida',
      success: 'Sėkmė'
    },
    form: {
      editTitle: 'Redaguoti saloną',
      newTitle: 'Naujas salonas',
      nameLabel: 'Salono pavadinimas *',
      namePlaceholder: 'Grožio salonas "Bella"',
      cityLabel: 'Miestas *',
      cityPlaceholder: 'Vilnius',
      addressLabel: 'Adresas *',
      addressPlaceholder: 'Gedimino pr. 1',
      postalCodeLabel: 'Pašto kodas',
      postalCodePlaceholder: '01103',
      phoneLabel: 'Telefonas',
      phonePlaceholder: '+370 600 12345',
      workingHoursLabel: 'Darbo laikas',
      workingHoursPlaceholder: 'Pr-Pn: 9:00-18:00, Št-Sk: 10:00-16:00',
      isActiveLabel: 'Aktyvus salonas',
      save: 'Išsaugoti',
      saving: 'Išsaugoma...',
      cancel: 'Atšaukti',
      requiredFieldsError: 'Prašome užpildyti visus privalamus laukus',
      updateSuccess: 'Salono informacija atnaujinta',
      createSuccess: 'Naujas salonas pridėtas',
      saveError: 'Nepavyko išsaugoti salono informacijos'
    }
  },

  // Social Proof
  socialProof: {
    someoneFrom: 'Kažkas iš',
    justBought: 'ką tik įsigijo',
    minutesAgo: 'prieš {n} min.',
    hoursAgo: 'prieš {n} val.',
    verifiedPurchase: 'Patvirtintas pirkimas',
    close: 'Uždaryti',
  },

  // Discount Codes
  discountCodes: {
    title: 'Nuolaidų kodai',
    description: 'Valdykite nuolaidų kodus',
    addCode: 'Pridėti kodą',
    noCodes: 'Nuolaidų kodų nėra',
    placeholder: 'Nuolaidos kodas',
    apply: 'Taikyti',
    applied: 'Kodas pritaikytas!',
    alreadyApplied: 'Kodas jau pritaikytas',
    invalidCode: 'Neteisingas kodas',
    codeNotFound: 'Toks nuolaidos kodas nerastas arba neaktyvus',
    codeExpired: 'Kodas nebegalioja',
    maxUsesReached: 'Šis kodas jau buvo panaudotas maksimalų skaičių kartų',
    expired: 'Šio kodo galiojimo laikas pasibaigė',
    minOrderNotMet: 'Per maža užsakymo suma',
    minOrderRequired: 'Minimali užsakymo suma',
    totalDiscount: 'Bendra nuolaida',
    discountCodesLabel: 'Nuolaidos kodai',
  },
};
